import { Upload } from "lucide-react";
import ForgotPassword from "../pages/ForgotPassword";
import { MdOtherHouses } from "react-icons/md";

export const translations = {
  en: {
    // Booking Flow
    bookAppointment: "Book Appointment",
    selectService: "Select Service",
    selectDate: "Select Date",
    selectTime: "Select Time",
    bookNow: "Book Now",
    bookingConfirmed: "Booking Confirmed!",
    appointmentScheduled: "Your appointment has been successfully scheduled",
    appointmentScheduledEth: "Your appointment for {{service}} is scheduled for {{dateTime}}",
    queueNumber: "Queue Number",
    dateAndTime: "Date & Time",
    counter: "Counter",
    notifications: "Notifications",
    enabled: "Enabled",
    notEnabled: "Not enabled",
    bookAnotherAppointment: "Book Another Appointment",
    backToProfile: "Back to Profile",
    today: "Today",
    currentWeek: "Current Week",
    nextWeek: "Next Week",
    countersAvailable: "counters available",
    counterAvailable: "counter available",
    calendarType: "Calendar Type",
    switchToEthiopian: "Switch to Ethiopian",
    switchToGregorian: "Switch to Gregorian",
    back: "Back",
    service: "Service",
    note: "Note: We couldn't enable notifications for this booking. You may need to check your notification permissions.",
    tryEnablingNotificationsAgain: "Try enabling notifications again",

    // Navigation & Common
    findServices: "Find Services",
    buyItems: "Buy Items",
    profile: "Profile",
    login: "Login",
    signup: "Sign Up",
    logout: "Logout",
    search: "Search",
    filter: "Filter",
    clearFilters: "Clear Filter",
    clear: "Clear",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    loading: "Loading...",
    addImage: "Add Image",
    saveChanges: "Save Changes",
    saving: "Saving...",
    about: "About",
    editProfile: "Edit Profile",
    editProviderProfile: "Add Service Provider Profile",

    // Landing Page
    findProviders: "Discover Experts in Your Area: The Ultimate Service Directory",
    findProvidersSubtitle: "Where Quality Meets Convenience in Your Area",
    findSellers: "Find New and Used Items for Sale",
    findSellersSubtitle: "Search for what you need and contact sellers directly from here",
    searchPlaceholder: "Search for services...",
    cities: "Select Cities",
    services: "Select Services",
    sortBy: "Sort by",
    rating: "Rating",
    reviews: "Reviews",
    noProviders: "No service providers found",
    noProvidersDesc: "Be the first to offer services in this area",
    noProvidersFound: "No Service providers match your search criteria",
    signUpAsProvider: "Sign up as Service Provider",
    anonymousProvider: "Anonymous Service Provider",
    more: "more",
    
    findServicesAndShopItems: "Find Services & Shop Items",
    oneStopPlatform: "Your one-stop platform for local services and marketplace",
    findServicesOnly: "Find Services",
    shopItems: "Shop Items",
    topServiceProviders: "Selected Services",
    viewAll: "View All",
    latestItems: "Selected Items",
    searchItems: "Search Items by Name or Product Number",
    tryAdjustingFilters: "Try adjusting your filters or search terms",
    noItemsFound: "No items found",
    allCategories: "All Categories",
    allConditions: "All Conditions",
    minPrice: "Min Price",
    maxPrice: "Max Price",

        //Routing page 
    chooseYourRole: "Choose Your Role",
    getStartedBySelecting: "Get started by selecting how you want to use our platform",
    signUpAsServiceProvider: "Sign up as Service Provider",
    signUpAsSeller: "Sign up as Seller",
    

    // Availability
    weekdays: "Weekdays",
    weekends: "Weekends",
    evenings: "Evenings",
    emergency: "Emergency",

    // Form Labels
    location: "Location",
    serviceLocations: "Service Locations",
    shortDescription: "Short Description",
    serviceDetails: "Service Details",
    servicesOffered: "Services Offered",
    yearsExperience: "Years of Experience",
    hourlyRate: "Hourly Rate (ETB)",
    availability: "Availability",
    contactInfo: "Contact Information",
    whatsappNumber: "WhatsApp Number",
    telegramUsername: "Telegram Username",
    messengerUsername: "Messenger Username",
    phoneNumber: "Phone Number",
    workGallery: "Work Gallery",
    profileImage: "Profile Image",
    basicInfo: "Basic Information",
    sellerInformation: "Seller",
    loginToContactSeller: "Log in to contact seller",
    welcomeToYourStore: "Welcome to Your Store",
    manageYourItems: "Manage your items and connect with customers",

    // Placeholders
    selectCity: "Select your city",
    shortDescriptionPlaceholder: "Brief description of your services",
    serviceDetailsPlaceholder: "Detailed description of your services and expertise",
    whatsappPlaceholder: "e.g., +251912345678",
    telegramPlaceholder: "e.g., @username",
    messengerPlaceholder: "e.g., username",
    phonePlaceholder: "e.g., +251912345678",
    optional: "Optional",

    // Contact Methods
    contactViaWhatsApp: "Contact via WhatsApp",
    contactViaTelegram: "Contact via Telegram",
    contactViaMessenger: "Contact via Messenger",
    call: "Call",

    // Footer
    support: "Support",
    contactUs: "Contact Us",
    helpCenter: "Help Center",
    faq: "FAQ",
    legal: "Legal",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    cookiePolicy: "Cookie Policy",
    connectWithUs: "Connect With Us",
    allRightsReserved: "All Rights Reserved",

    myItems: "My Items",
    storeProfile: "Store Profile",
    storeImage: "Store Image",
    storeName: "Store Name",
    storeDescription: "Store Description",
    startAdding: "Start adding items to your store",
    noItems: "No Items Yet",

    getInTouch: "Get in Touch",
    sendMessage: "Send us a Message",
    name: "Name",
    businessName: "Business Name",
    email: "Email",
    message: "Message",
    sendMessageButton: "Send Message",


    cPhoneNumber: "+251 93 544 3037",
    address: "Addis Ababa, Ethiopia",

    helpCenterTitle: "Help Center",
    gettingStartedTitle: "Getting Started",
    howToFindServiceProvider: "How to find a service provider",
    howToFindServiceProviderDesc: "Browse our directory of service providers, use filters to narrow down your search, and read reviews from other customers to make an informed decision.",
    becomingServiceProvider: "Becoming a service provider",
    becomingServiceProviderDesc: "Sign up for an account, complete your profile with relevant information about your services, and start connecting with customers in your area.",
    commonIssuesTitle: "Common Issues",
    accountManagementTitle: "Account Management",
    resetPassword: "How to reset your password",
    updateProfileInfo: "Updating your profile information",
    managePrivacySettings: "Managing your privacy settings",
    serviceIssuesTitle: "Service Issues",
    contactServiceProvider: "Contacting service providers",
    leaveReviews: "Leaving reviews and ratings",
    reportProblems: "Reporting problems with a service",
    supportOptionsTitle: "Support Options",
    supportDesc: "Need more help? Contact our support team through any of these channels:",
    supportEmail: "Email: support@warkashop.com",
    supportPhone: "Phone: +251 93 544 3037",
    supportChat: "Live Chat: Available on Telegram",

    faqTitle: "Frequently Asked Questions",
    faqQuestion1: "How do I find a service provider?",
    faqAnswer1: "You can search for service providers using our search bar, browse by category, or use filters to narrow down your options. Each provider's profile includes reviews, ratings, and detailed information about their services.",
    faqQuestion2: "How do I become a service provider?",
    faqAnswer2: "Sign up for an account, then enable service provider mode in your profile settings. Complete your provider profile with information about your services, experience, and availability.",
    faqQuestion3: "How do payments work?",
    faqAnswer3: "Payments are handled directly between you and the service provider. We recommend discussing payment terms and methods before starting any service.",
    faqQuestion4: "Can I leave a review for a service provider?",
    faqAnswer4: "Yes, you can leave a review and rating for any service provider you've worked with. Your feedback helps other users make informed decisions.",
    faqQuestion5: "What if I have a problem with a service?",
    faqAnswer5: "First, try to resolve the issue directly with the service provider. If that doesn't work, you can contact our support team for assistance.",
    faqQuestion6: "How do I update my profile information?",
    faqAnswer6: "Log in to your account, go to your profile page, and click the edit button to update your information.",
    faqStillHaveQuestionsTitle: "Still have questions?",
    faqStillHaveQuestionsDesc: "Can't find the answer you're looking for? Please contact our support team.",
    faqContactSupport: "Contact Support",

    privacyPolicyTitle: "Privacy Policy",
    infoCollectTitle: "Information We Collect",
    infoCollectDesc: "We collect information that you provide directly to us, including:",
    infoCollectItem1: "Name and contact information",
    infoCollectItem2: "Profile information and preferences",
    infoCollectItem3: "Service history and reviews",
    infoCollectItem4: "Communication records",
    howWeUseInfoTitle: "How We Use Your Information",
    howWeUseInfoDesc: "We use the information we collect to:",
    howWeUseInfoItem1: "Provide and improve our services",
    howWeUseInfoItem2: "Communicate with you",
    howWeUseInfoItem3: "Personalize your experience",
    howWeUseInfoItem4: "Ensure platform safety and security",
    infoSharingTitle: "Information Sharing",
    infoSharingDesc: "We may share your information with:",
    infoSharingItem1: "Service providers and partners",
    infoSharingItem2: "Other users (as necessary for service provision)",
    infoSharingItem3: "Legal authorities when required",
    yourRightsTitle: "Your Rights",
    yourRightsDesc: "You have the right to:",
    yourRightsItem1: "Access your personal information",
    yourRightsItem2: "Correct inaccurate information",
    yourRightsItem3: "Request deletion of your information",
    yourRightsItem4: "Opt-out of marketing communications",
    contactUsTitle: "Contact Us",
    contactUsDesc: "If you have any questions about our Privacy Policy, please contact us at",
    contactUsEmail: "support@warkashop.com",

    termsTitle: "Terms of Service",
    acceptanceTitle: "1. Acceptance of Terms",
    acceptanceDesc: "By accessing and using ServiceConnect, you agree to be bound by these Terms of Service and all applicable laws and regulations.",
    userResponsibilitiesTitle: "2. User Responsibilities",
    userResponsibilitiesDesc: "As a user of our platform, you agree to:",
    userResponsibilitiesItem1: "Provide accurate and complete information",
    userResponsibilitiesItem2: "Maintain the security of your account",
    userResponsibilitiesItem3: "Comply with all applicable laws and regulations",
    userResponsibilitiesItem4: "Respect other users' rights and privacy",
    providerTermsTitle: "3. Service Provider Terms",
    providerTermsDesc: "Service providers must:",
    providerTermsItem1: "Provide accurate service descriptions",
    providerTermsItem2: "Maintain professional standards",
    providerTermsItem3: "Comply with local regulations",
    providerTermsItem4: "Respond to client communications promptly",
    prohibitedActivitiesTitle: "4. Prohibited Activities",
    prohibitedActivitiesDesc: "Users may not:",
    prohibitedActivitiesItem1: "Misrepresent their identity or qualifications",
    prohibitedActivitiesItem2: "Engage in fraudulent activities",
    prohibitedActivitiesItem3: "Harass or harm other users",
    prohibitedActivitiesItem4: "Violate intellectual property rights",
    contactInfoTitle: "5. Contact Information",
    contactInfoDesc: "For questions about these Terms of Service, please contact us at",
    contactInfoEmail: "support@warkashop.com",

    cookiePolicyTitle: "Cookie Policy",
    whatAreCookiesTitle: "What Are Cookies",
    whatAreCookiesDesc: "Cookies are small text files that are placed on your computer or mobile device when you visit our website. They help us provide you with a better experience and understand how you use our service.",
    typesOfCookiesTitle: "Types of Cookies We Use",
    essentialCookiesTitle: "Essential Cookies",
    essentialCookiesDesc: "Required for basic website functionality and security. Cannot be disabled.",
    preferenceCookiesTitle: "Preference Cookies",
    preferenceCookiesDesc: "Remember your settings and preferences for a better experience.",
    analyticsCookiesTitle: "Analytics Cookies",
    analyticsCookiesDesc: "Help us understand how visitors interact with our website.",
    managingCookiesTitle: "Managing Cookies",
    managingCookiesDesc1: "You can control and/or delete cookies as you wish. You can delete all cookies that are already on your computer and you can set most browsers to prevent them from being placed.",
    managingCookiesDesc2: "To learn more about how to manage cookies, visit:",
    manageCookiesChrome: "Chrome: Settings → Privacy and Security → Cookies",
    manageCookiesFirefox: "Firefox: Options → Privacy & Security",
    manageCookiesSafari: "Safari: Preferences → Privacy",
    updatesPolicyTitle: "Updates to This Policy",
    updatesPolicyDesc: "We may update this Cookie Policy from time to time. Please check back regularly to stay informed of any updates.",

    backToDetails: "Back to Details", 
    onlyXLeft: "Only {{count}} left",
    noReviewsYet: "No reviews yet",
    priceDisplay: "ETB {{price}}",

    addNewItem: "Add New Item",
    images: "Images",
    itemName: "Item Name",
    description: "Description",
    priceETB: "Price (ETB)",
    quantity: "Quantity",
    category: "Category",
    condition: "Condition",
    cancel: "Cancel",
    cancelBack: "Back",
    cancelDiscard: "Cancel",
    addItem: "Add Item",
    addingItem: "Adding...",
    required: "Required",
    imageRequired: "Please add at least one image",
    itemAddedSuccess: "Item added successfully",
    itemAddedFail: "Failed to add item",
    itemRemoveSuccess: "Item removed successfully",
    itemRemoveError: "Failed to remove item",
    itemUpdatedSuccess: "Item updated successfully",
    selectCategory: "Select a category",
    selectCondition: "Select condition",

    aiWizardTitle: "AI-Powered Listing",
    aiWizardStep1: "Add Photo",
    aiWizardStep2: "AI Analysis",
    aiWizardStep3: "Review & Edit",
    aiWizardCapture: "Take a photo or select an image of your item",
    aiWizardTakePhoto: "Take Photo",
    aiWizardChooseGallery: "Choose from Gallery",
    aiWizardAnalyzing: "AI is analyzing your item...",
    aiWizardAnalyzingDesc: "Identifying the product, category, and suggested price",
    aiWizardReview: "Review your listing details",
    aiWizardEditHint: "You can edit any field before publishing",
    aiWizardSuggestedPrice: "AI Suggested Price",
    aiWizardRetry: "Try Again",
    aiWizardAnalysisFailed: "Could not analyze the image. Please try again or fill in manually.",
    aiWizardFillManually: "Fill Manually",
    aiWizardPoweredBy: "Powered by AI",
    aiWizardChangeImage: "Change Image",
    aiWizardPublish: "Publish Listing",
    aiWizardNext: "Next",
    aiWizardBack: "Back",
    aiWizardKeywords: "Keywords",
    aiWizardPriceRange: "Price Range (ETB)",
    aiWizardListingLanguage: "Listing language",

    imageUploadSuccess: "Image uploaded successfully!",
    imageUploadError: "Failed to upload image. Please try again.",
    imageRemoveSuccess: "Image removed successfully!",
    imageRemoveError: "Failed to remove image. Please try again.",
    imageAlt: "Uploaded Image",
    dropImage: "Drop the image here",
    dragOrClick: "Add image",
    maxFileSize: "Max: 5MB",
    supportedFormats: ": JPEG, PNG, WebP",
    writeReview: "Write a Review",
    noContactMethods: "Social contact methods not provided",
    yourReview: "Your Review",
    reviewItem: "Review Item",
    shareYourExperience: "Share Your Experience",
    failedToSubmitReview: "Failed to submit review.",
    submitReview: "Submit Review",
    reviewSubmitted: "Review submitted successfully!",
    shareYourThoughts: "Share Your Thoughts",
    pleaseWriteReview: "Please write a review",
    yearsexp : "Years Exp.",
    setAsUser: "Set as Regular User",
    regularUserDesc: "Use the platform as a regular user",
    noImagesAvailable: "No images available",
    reviewProvider: "Review {{providerName}}",
    shareExperience: "Share your experience with this service provider",
    serviceReceived: "Service Received",
    servicePlaceholder: "e.g., Plumbing Repair, House Cleaning",
    experiencePlaceholder: "Share your experience...",
    loginRequired: "Login Required for this action",
    ratingRequired: "Please select a rating",
    serviceRequired: "Please specify the service",
    reviewRequired: "Please write a review",
    reviewSuccess: "Review submitted successfully!",
    reviewFailed: "Failed to submit review",
    submitting: "Submitting...",  
    contactProvider: "Contact {{providerName}}",
    loginToViewContact: "Please log in to view contact information and connect with this service provider.",
    loginToContact: "Log In to Contact",
    callProvider: "Call {{phone}}",
    featuredProviders: "Featured Service Providers",
    dropImageHere: "Drop the image here",
    dragDropOrClick: "Drag & drop an image here, or click to select",
    uploading: "Uploading...",
    pleaseSaveProfile: "Please save your profile first before adding gallery images",
    pleaseProvideEmailOrPhone: "Please provide either an email or phone number",
    accountCreated: "Account created successfully! You can now log in.",
    failedToCreateAccount: "Failed to create account",
    createYourAccount: "Create your account",
    signIn: "Sign in",
    fullName: "Full Name",
    fullNameRequired: "Full name is required",
    fullNameMinLength: "Full name must be at least 2 characters",
    enterFullName: "Enter your full name",
    businessNameOptional: "Business Name (Optional)",
    enterBusinessName: "Enter your business name (if applicable)",
    emailRequiredIfPhoneNotProvided: "Email address (Required if phone not provided)",
    invalidEmail: "Invalid email address",
    phoneRequiredIfEmailNotProvided: "Phone number (Required if email not provided)",
    invalidPhoneNumber: "Please enter a valid international phone number (e.g., +1234567890)",
    password: "Password",
    passwordRequired: "Password is required",
    passwordMinLength: "Password must be at least 6 characters",
    confirmPassword: "Confirm Password",
    confirmPasswordRequired: "Please confirm your password",
    passwordsDoNotMatch: "Passwords do not match",
    creatingAccount: "Creating account...",
    signUp: "Sign up",
    signInToYourAccount: "Sign in to your account",
    or: "Or",
    failedToLogin : "Failed to login",
    userNotFound: "Couldn't find the user. Please check your credentials.",
    networkError: "Network error. Please check your internet connection.",
    infoNotFound: "The requested information was not found.",
    incorrectPassword: "Incorrect password. Please try again.",
    noAccountFound: "No account found with this information.",
    switchToUser: "Switch to User Mode",
    switchToUserSuccess: "Successfully switched to user mode",
    switchToUserError: "Failed to switch to user mode",
    switchToProvider: "Switch to Service Mode",
    profileSwitchSuccess: "Successfully switched to service provider mode",
    profileSwitchError: "Failed to switch to service provider mode",
    switchToSeller: "Switch to Seller Mode",
    switchToSellerSuccess: "Successfully switched to seller mode",
    switchToSellerError: "Failed to switch to seller mode",
    switchProfile: "Switch Profile",
    loginSuccess: "Successfully logged in",
    logoutSuccess: "Successfully logged out",
    loginError: "Failed to log in",
    signupSuccess: "Successfully signed up",
    signupError: "Failed to sign up",

    //chat 
    startChat: "Start Chat",
    loginToChat: "Login to Chat",
    typeMessage: "Type a message...",
    noConversations: "No Conversations Yet",
    startNewChat: "Start a new chat with a Service provider or Seller",
    send: "Send",
    chatWith: "Chat with {{name}}",
    messageSent: "Message sent",
    messageError: "Failed to send message",
    loadingMessages: "Loading messages...",
    chatHistory: "Chat History",
    newMessage: "New Message",
    unreadMessages: "Unread Messages",
    lastActive: "Last active {{time}}",
    online: "Online",
    offline: "Offline",
    messages: "Messages",
    available: "available", 
    oldPrice: "Price",
    newPrice: "Discounted Price",
    menu: "Menu",
    moreLinks: "More Links",
    appName: "WARKA",
    allServices: "All Services",
    allCities: "All Cities",
    uploadImages: "Upload Images",
    editItem: "Edit Item",
    updateItem: "Update Item",
    noBanner: "No banner",
    onSale: "On sale",
    new: "New",
    soldOut: "Sold out",
    limitedStock: "Limited stock",
    sponsored: "Sponsored",
    itemDescription: "Item Description",
    profileUpdateSuccess: "Profile updated successfully",
    profileUpdateFailure: "Failed to update profile",
    seeMoreFromSeller: "See More from Seller",
    city: "City",
    regularUser: "User Profile",
    sellerPage: "Seller Profile",
    providerPage: "Service Profile",
    signupWithGoogle: "Sign up with Google",
    signInWithGoogle: "Sign in with Google",
    dontHaveAccount: "Dont have an account?",
    createAccount: "Create Account",
    itemDetails: "Item Details",
    seller: "Seller",
    viewStore: "View Store",
    customerReviews: "Customer Reviews",
    forgotPassword: "Forgot Password",
    sendResetEmail: "Send Reset Email",
    backToLogin: "Back to Login",
    phone: "Phone",
    sendOTP: "Send Verification Code",
    otpSent: "OTP sent successfully",
    verifyOTP: "Verify OTP",
    pleaseLogInToViewSavedItems: "Please log in to view saved items.",
    loadingSavedItems: "Loading saved items...",
    noSavedItemsFound: "No saved items found.",
    savedItemsServices: "Saved Items and Services",
    itemSavedSuccess: "Item saved successfully",
    itemSaveError: "Failed to save item",
    itemRemovedFromSaved: "Item removed from saved items",
    itemRemoveErrorSaved: "Failed to remove item",
    savedItemsTab: "Saved Items",
    savedServicesTab: "Saved Services",
    noSavedProvidersFound: "No saved services providers found.",
    savedItems: "Saved",   
    providerSavedSuccess: "Service Provider saved successfully",
    providerSaveError: "Failed to save Service provider",
    providerRemovedFromSaved: "Service Provider removed from saved items",
    providerRemoveError: "Failed to remove Service provider",
    messageSentSuccess: "Message sent successfully",
    messageSentError: "Failed to send message",
    sending:  "Sending...",
    Saving: "Saving...",
    selectedServices: "Selected Services",
    categories: "Categories",
    buisnessLocation: "Business Location",
    serviceCategory: "Service Category",
    selectServiceCategory: "Service Category",
    signingIn: "Signing in...",
    selected: "Selected",
    noneSelected: "None Selected",
    selectServiceLocations: "Select Service Location",
    pickupLocations: "Pickup Locations",
    addPickupLocation: "Add Pickup Location",
    subcategory: "Sub-Category",
    selectSubcategory: "Select Sub-Category",
    selectCategoryFirst: "Select a category first",
    addLocation: "Add Location",
    status: "Status",
    buyer: "Buyer",
    price: "Price",
    viewSeller: "View Seller",
    viewProfile: "View Profile",
    pickupLocation: "Pickup Location",
    myPurchases: "My Purchases",
    myStoreOrders: "My Store Orders",
    newOrders: "New",
    completed: "Completed",
    changePickupLocation: "Change Pickup Location",
    cancelOrder: "Cancel Order",
    pending: "Pending",
    confirmed: "Confirmed",
    confirm: "Confirm",
    ready: "Ready",
    complete: "Complete",
    noOrdersFound: "No orders found",
    noPurchaseFound: "No purchases found",
    loadingOrders: "Loading orders...",
    orders: "Purchases & Orders",
    orderNow: "Order Now",
    // New order system keys
    cart: "Cart",
    activeOrders: "Active",
    orderHistory: "History",
    sendOrders: "Send Orders",
    cartEmpty: "Your cart is empty",
    ordersSent: "Orders sent successfully!",
    trackYourOrders: "Track your purchases and orders",
    manageIncomingOrders: "Manage incoming orders from buyers",
    pendingOrdersNeedAttention: "pending orders need your attention",
    itemRemovedFromCart: "Item removed from cart",
    changeLocation: "Change Location",
    locationUpdated: "Location updated",
    orderConfirmed: "Order confirmed",
    orderMarkedReady: "Order marked as ready",
    orderCompleted: "Order completed",
    orderCancelled: "Order cancelled",
    inYourCart: "In your cart",
    item: "item",
    items: "items",
    remove: "Remove",
    noLocationSelected: "No location selected",
    total: "Total",
    noActiveOrders: "No active orders",
    noOrderHistory: "No order history yet",
    noPendingOrders: "No pending orders",
    storeOrders: "Store Orders",
    viewStoreOrders: "View Store Orders",
    viewPurchases: "View My Purchases",
    statusPendingBuyerGuide: "Your order has been sent. Waiting for the seller to confirm.",
    statusConfirmedBuyerGuide: "The seller has confirmed your order. It's being prepared.",
    statusReadyBuyerGuide: "Your order is ready for pickup! Visit the seller to collect it.",
    statusCompletedBuyerGuide: "Order completed. Thank you for your purchase!",
    statusCancelledBuyerGuide: "This order has been cancelled.",
    statusPendingSellerGuide: "New order received. Please review and confirm.",
    statusConfirmedSellerGuide: "You confirmed this order. Prepare it for the buyer.",
    statusReadySellerGuide: "Order is ready. Waiting for buyer to pick up.",
    statusCompletedSellerGuide: "Order completed successfully.",
    statusCancelledSellerGuide: "This order has been cancelled.",
    statusCartGuide: "Item is in your cart. Send your orders when ready.",
    selectPickupLocation: "Select Pickup Location",
    scanToPickUp: "Scan to Pick Up",
    scanToCheckIn: "Scan QR Code to Check In",
    // SendersTravelers.tsx specific translations
    sendersTravelers: "Find Travelers & Send Items",
    iAmSender: "I am a Sender",
    iAmTraveler: "I am a Traveler",
    iAmListings: "My Travels",
    travelerDetails: "Traveler Details",
    fromLocation: "From City",
    toLocation: "To City",
    travelDate: "Travel Date",
    maxSize: "Max Size",
    maxWeight: "Max Weight (Kg)",
    notes: "Notes",
    saveTravelerDetails: "Save Traveler Details",
    senderSearch: "Sender Search",
    travelDateFrom: "Travel Date From",
    travelDateTo: "Travel Date To",
    itemType: "Item Type",
    any: "Any",
    fullLuggage: "Luggage",
    singleItem: "Single Item",
    electronics: "Electronics",
    searchTravelers: "Search Travelers",
    searching: "Searching...",
    searchResults: "Search Results",
    noResultsFound: "Loading Travels...",
    listingDetail: "Listing Detail",
    createdOn: "Created On",
    close: "Close",
    listingSaveFailure: "Failed to save listing",
    listingSaveSuccess: "Listing saved successfully",
    listingFetchFailure: "Failed to fetch listings",
    detailFetchFailure: "Failed to fetch listing details",
    senderSearchFailure: "Failed to search listings",
    noListingsFound: "No listings found",
    deleteListingConfirmation: "Are you sure you want to delete this listing?",
    deleteListingFailure: "Failed to delete listing.",
    deleteListingSuccess: "Listing deleted successfully.",
    travelDateFromBeforeCurrent: "Travel Date From cannot be before today.",
    travelDateFromAfterTo: "Travel Date From cannot be after Travel Date To.",
    findJobs: "Find Jobs",
    findEvents: "Find Events",
    comingSoon: "Coming Soon...",
    startSellingOnline: "Start Selling Online",
    advertiseYourServicesOnline: "Advertise Your Services Online",
    exploreOurServices: "Explore Our Services",
    marketplace: "Marketplace",
    buyAndSellItems: "Buy and sell items",
    findOrOfferServices: "Find or offer services",
    findTravellers: "Find Travellers",
    sendItemsWithTravellers: "Send items with travellers",
    findOrPostJobs: "Find or post job vacancies",
    discoverLocalEvents: "Discover local events",
    findRealEstate: "Real Estate",
    browseProperties: "Browse properties",
    loginRequiredforTravel: "Login required to add traveler details",
    recentlyViewedItems : "Recently Viewed Items",
    recentLoading: "Loading...",
    recentlyViewed: "Recently Viewed",
    newlyAdded: "Newly Added",
    editDisplayName: "Edit Display Name",
    businessNameCity: "Business Name, City",
    customLabel: "Custom",
    displayNameHelp: "This is how the location will appear to customers",
    noPickupLocationsAvailable: "No pickup locations available",
    selectLocation: "Select This Location",
    errorWrongCredentials: "Email or password is incorrect",
    errorUserNotFound: "No account found with this email. Please sign up first.",
    errorEmailExists: "An account with this email already exists",
    errorInvalidEmail: "Please enter a valid email address",
    errorTooManyAttempts: "Too many failed login attempts. Please try again later",
    errorWeakPassword: "Password should be at least 6 characters",
    errorPopupClosed: "Sign in was cancelled",
    errorRequiresRecentLogin: "Please log in again to complete this action",
    errorNetworkIssue: "Network error. Please check your connection",
    errorInvalidPhone: "The phone number format is incorrect",
    errorInvalidOTP: "Incorrect verification code",
    errorOTPExpired: "Verification code has expired. Please request a new one",
    errorMissingOTP: "Please enter the verification code",
    errorAuthGeneric: "Authentication error. Please try again",
    errorGeneric: "An error occurred. Please try again",
    requiredField: "This field is required",
    noPickupLocations: "No pickup locations available",
    myProfiles: "My Profiles",
    createSellerProfile: "Create Seller Profile",
    sellerProfileNeeded: "Seller Profile Needed",
    sellerProfileNeededDesc: "Create a seller profile to start listing items for sale.",
    createProviderProfile: "Create Provider Profile",
    home: "Home",
    shop: "Shop",
    chat: "Chat",
    account: "Account",
    tapToCreate: "Tap to create",
    helpSupport: "Help & Support",
    theme: "Theme",
    themeMidnight: "Midnight",
    themeDark: "Dark",
    themeLight: "Light",
    referralEarnings: "Referral Points",
    referralCode: "Referral Code",
    referralCodeCopied: "Referral code copied to clipboard",
    regNumber: "Registration Number",
    referredByUser: "Do you have a referral code?",
    referralCodeHelp: "Enter the referral code you received from a friend",
    formattedCode: "Referral Code",
    passwordsNotMatch: "Passwords do not match",
    contact: "Contact",
    contactInformation: "Contact Information",
    completeOrder: "Complete Order",
    markReady: "Mark Ready",
    deleteOrder: "Delete Order",
    sellerPendingGuidance: "Please confirm this order when you're ready to process it.",
    sellerConfirmedGuidance: "Prepare the item and mark it as ready when the buyer can pick it up.",
    sellerReadyGuidance: "The buyer has been notified and can come to collect their order.",
    sellerCompletedGuidance: "This order has been completed. Thank you for your service!",
    buyerPendingGuidance: "Please select a pickup location. Waiting for seller confirmation.",
    buyerReadyGuidance: "Good news! Your order is ready for pickup at the selected location.",
    buyerConfirmedGuidance: "Your order has been confirmed! The seller is preparing your item.",
    buyerCompletedGuidance: "Your order has been completed. Thank you for your purchase",
    statusInfo: "Status Info",
    onboardingStep1Title: "Create Your Account 📝",
    onboardingStep1Desc: "Sign up easily with your Email or Phone number. Quickly set up your personal profile.",
    onboardingStep2Title: "Explore Items & Services 🛍️",
    onboardingStep2Desc: "Browse products, find services, and discover great deals near you. Search or filter to find exactly what you need.",
    onboardingStep3Title: "Buy or Sell with Confidence 🤝",
    onboardingStep3Desc: "Post items to sell, or contact sellers directly through secure chat. Arrange convenient pickup locations, or find someone traveling who can deliver.",
    onboardingStep4Title: "Connect and Collaborate ✨",
    onboardingStep4Desc: "Easily communicate via secure messaging. Coordinate details like price, pickup, delivery, or services directly in the app.",
    welcomeToWarka: "Welcome to Warka! 🎉",
    getStartedQuickly: "Get started quickly with these simple steps:",
    step: "Step",
    imageComingSoon: "Tutorial image will appear here",
    skip: "Skip",
    previous: "Previous",
    next: "Next",
    createNewAccount: "Create New Account",
    alreadyHaveAccount: "Already Have an Account?",
    goToProfile: "Go to Profile",
    createAccountOrLogin: "Create Account / Login",
    backToHome: "Home Page",
    whatWouldYouLikeToDo: "Connect, Buy, Sell, Travel — All in one place! Shop locally. Find services. Send globally. What would you like to do?",
    imAShopper: "I'm a Shopper",
    imASeller: "I'm a Seller",
    imAServiceProvider: "I'm a Service Provider",
    imLookingForServices: "I'm Looking for Services",
    imATraveler: "I'm a Traveler",
    iWantToSendItems: "I Want to Send Items",
    letsGetYouSetUp: "Let's Get You Set Up! 📝",
    shopperSetupDesc: "Create your shopper account to continue. Quickly sign up with your email or phone number.",
    sellerSetupDesc: "Create your seller account to continue. Quickly sign up with your email or phone number.",
    providerSetupDesc: "Create your service provider account to continue. Quickly sign up with your email or phone number.",
    seekerSetupDesc: "Create your account to continue finding services. Quickly sign up with your email or phone number.",
    travelerSetupDesc: "Create your traveler account to continue. Quickly sign up with your email or phone number.",
    senderSetupDesc: "Create your sender account to continue. Quickly sign up with your email or phone number.",
    setupDesc: "Create your account to continue. Quickly sign up with your email or phone number.",
    completeYourProfile: "Complete Your Profile 🚀",
    sellerProfilePrompt: "Create your seller profile, add your items, and set pickup locations.",
    shopperProfilePrompt: "Discover items near you, connect with sellers instantly.",
    serviceProviderProfilePrompt: "Create your service profile and list your expertise.",
    serviceSeekerProfilePrompt: "Search and connect with trusted professionals.",
    travelerProfilePrompt: "Create a traveler profile, add your trips and available luggage space.",
    senderProfilePrompt: "Find travelers going your way and send your items securely.",
    defaultProfilePrompt: "Complete your profile to get the most out of Warka.",
    greatChoice: "Great choice!",
    shopperSetup: "Let's quickly set up your shopper account.",
    sellerSetup: "Let's quickly set up your seller account.",
    providerSetup: "Let's quickly set up your service provider account.",
    seekerSetup: "Let's quickly set up your account to find services.",
    travelerSetup: "Let's quickly set up your traveler account.",
    senderSetup: "Let's quickly set up your sender account.",
    wouldYouLikeToCreateProfile: "Would you like to create your profile now?",
    yes: "Yes",
    setupUserProfile: "Set up your User Profile",
    userProfileDescription: "As a {{selectedPersona}}, you'll need a basic user profile.",
    createBasicProfile: "Create Basic Profile",
    signupSuccessful: "Sign up successful!",
    shopperTitle: "Shop with Confidence",
    shopperDesc: "Discover unique items from local sellers. Connect directly, arrange pickup, and support local businesses.",
    shopperFeature1: "Browse items by location and category",
    shopperFeature2: "Chat directly with sellers",
    shopperFeature3: "Arrange convenient pickups",
    shopperFeature4: "Save favorite items",

    sellerTitle: "Sell Your Items",
    sellerDesc: "List your products, connect with buyers, and grow your business locally without unnecessary fees.",
    sellerFeature1: "Easy product listing with photos",
    sellerFeature2: "Set your own prices",
    sellerFeature3: "Manage pickup locations",
    sellerFeature4: "Direct communication with buyers",

    providerTitle: "Offer Your Services",
    providerDesc: "Showcase your expertise, connect with clients, and grow your service business.",
    providerFeature1: "Create a professional profile",
    providerFeature2: "List your services and rates",
    providerFeature3: "Showcase your portfolio",
    providerFeature4: "Connect with potential clients",

    seekerTitle: "Find Local Services",
    seekerDesc: "Discover skilled professionals in your area for any service you need.",
    seekerFeature1: "Search by service type and location",
    seekerFeature2: "View provider portfolios and ratings",
    seekerFeature3: "Message providers directly",
    seekerFeature4: "Save favorite service providers",

    travelerTitle: "Travel & Earn",
    travelerDesc: "Share your travel plans, connect with senders, and earn by delivering items.",
    travelerFeature1: "Post your travel itinerary",
    travelerFeature2: "Specify available space",
    travelerFeature3: "Connect with senders",
    travelerFeature4: "Earn by delivering packages",

    senderTitle: "Send Items Globally",
    senderDesc: "Connect with travelers heading to your destination and send items safely and affordably.",
    senderFeature1: "Find travelers going to your destination",
    senderFeature2: "Arrange package delivery",
    senderFeature3: "Track your items",
    senderFeature4: "Rate and review travelers",
    keyFeatures: "Key Features",
    changeRole: "Change Role",
    addAllToCart: "Add All to Cart",
    adding: "Adding...",
    unsaveAll: "Unsave All",
    removing: "Removing...",
    noItemsToAdd: "No items to add to cart",
    allItemsAddedToCart: "All items added to cart",
    failedToAddItems: "Failed to add items to cart",
    noSavedItemsToRemove: "No saved items to remove",
    noSavedProvidersToRemove: "No saved service providers to remove",
    allItemsUnsaved: "All items have been unsaved",
    allProvidersUnsaved: "All service providers have been unsaved",
    failedToUnsaveItems: "Failed to remove saved items",
    addToCart: "Add to Cart",
    inCart: "In Cart",
    goToCart: "Go to Cart",
    verificationSuccess: "Verification successful",
    otpSentInfo: "Check your phone for the verification code",
    emailNotConfirmed: "Email not confirmed",
    invalidCredentials: "Invalid email or password",
    userAlreadyExists: "An account with this email already exists",
    passwordTooShort: "Password should be at least 6 characters",
    invalidPhoneFormat: "Please enter a valid phone number with country code (e.g., +1234567890)",
    invalidOTP: "Invalid verification code. Please try again.",
    examplePhoneFormat: "Example: Choose +251(Ethiopia) as country code and enter your phone number starting with 07 or 09",
    //examplePhoneFormat: "Signup or Login with Ethiopian phone numbers is temporarily unavailable. ",
    //"Example: +251912345678",
    tooShort: "Too short",
    tooLong: "Too long",

    loginWithEmail: "Login with Email",
    loginWithPhone: "Login with Phone",
    loginWithWhatsApp: "Login with WhatsApp",
    loginWithTelegram: "Login with Telegram",
    loginWithGoogle: "Login with Google",
    loginWithFacebook: "Login with Facebook",

    verificationCode: "Verification Code",
    verifying: "Verifying...",

    registerWithEmail: "Register with Email",
    registerWithPhone: "Register with Phone",
    registerWithTelegram: "Register with Telegram",
    registerWithGoogle: "Register with Google",
    registerWithFacebook: "Register with Facebook",

    register: "Register",
    verifyAndRegister: "Verify and Register",
    enterEmailInstructions: "Enter your email address to receive a password reset link.",
    sendResetLink: "Send Reset Link",

    resetLinkSent: "Reset link sent!",
    checkEmailForInstructions: "Check your email for further instructions.",
    passwordResetComplete: "Password Reset Complete!",
    createNewPassword: "Create New Password",
    redirectingToLogin: "Redirecting to login...",
    enterNewPasswordBelow: "Enter your new password below.",
    newPassword: "New Password",
    updating: "Updating...",
    passwordResetSuccess: "Password reset successful!",
    youCanNowLogin: "You can now login with your new password.",
    invalidOrExpiredResetLink: "This password reset link is invalid or has expired.",
    passwordResetError: "Failed to reset password.",
    addedToCart: "Added to cart",
    // Account Center
    accountCenter: "Account Center",
    manageProfiles: "Manage Profiles",
    providerProfile: "Provider Profile",
    sellerProfile: "Seller Profile",
    deactivate: "Deactivate",
    deactivateProviderConfirmation: "Are you sure you want to deactivate your provider profile? It will be hidden from search results.",
    deactivateSellerConfirmation: "Are you sure you want to deactivate your seller profile? Your listings will be hidden from the marketplace.",
    confirmDeactivate: "Confirm",
    processing: "Processing...",
    noProfilesToManage: "You don't have any additional profiles to manage.",
    dangerZone: "Danger Zone",
    deleteAccount: "Delete Account",
    deleteAccountWarning: "Warning: This action cannot be undone!",
    deleteAccountConfirmation: "Deleting your account will permanently remove all your data, including your profiles, listings, and activity history.",
    confirmDelete: "Confirm Delete",
    providerProfileDeactivated: "Provider profile deactivated",
    sellerProfileDeactivated: "Seller profile deactivated",
    errorDeactivatingProfile: "Error deactivating profile",
    accountDeletionRequested: "Account deletion requested. You will be contacted shortly.",
    errorDeletingAccount: "Error requesting account deletion",
    // Account Center Additional Translations
    activate: "Activate",
    activateProviderConfirmation: "Are you sure you want to activate your provider profile? It will become visible in search results.",
    activateSellerConfirmation: "Are you sure you want to activate your seller profile? Your listings will become visible in the marketplace.",
    confirmActivate: "Confirm Activation",
    active: "Active",
    providerProfileDeactivatedInfo: "Your provider profile is currently deactivated. Activate it to make your services visible.",
    sellerProfileDeactivatedInfo: "Your seller profile is currently deactivated. Activate it to make your listings visible.",
    deleteAccountPoint1: "All profile information and settings",
    deleteAccountPoint2: "Listings and services you have created",
    deleteAccountPoint3: "Message history and connections",
    deleteAccountPoint4: "All activity and transaction history",
    profileManagementInfo: "Profile management lets you control which aspects of your account are visible. Deactivating a profile hides it but keeps your data intact.",
    dangerZoneWarning: "Actions in this section can permanently affect your account and data. Please proceed with caution and make sure you understand the consequences.",
    providerProfileInfo: "Your provider profile is currently activated. Deactivating makes your services invisible to other users.",
    sellerProfileInfo: "Your seller profile is currently activated. Deactivating it to make your listings invisible to other users.",
    
    phoneVerificationRequired: "Phone registration requires OTP verification. A 6-digit code will be sent to your phone.",
    emailVerificationSent: "A verification email has been sent to your email address",
    checkYourEmail: "Check Your Email",
    verificationEmailSentDescription: "We've sent a verification email to your inbox. Please click the link in the email to verify your account.",
    checkSpamFolder: "If you don't see the email, please check your spam folder.",
    appliedViaLink: "Applied via link",
    copy: "Copy",
    share: "Share Link",
    levelInfoAriaLabel: "Show level information",
    levelLabel: "Level",
    payoutLabel: "Payout",
    closeModal: "Close",
    levelInfoTitle: "Referral Levels & Payouts",
    levelInfoDesc1: "Earn points by referring new users to Warka! The more users you refer and the more profiles they create, the higher your level and potential payout.",
    howToEarnPoints: "How Points are Calculated:",
    pointsPerReferral: "+25 points for each user who signs up using your code.",
    pointsPerSeller: "+50 additional points if your referred user creates a Seller profile.",
    pointsPerProvider: "+50 additional points if your referred user creates a Service Provider profile.",
    levelsAndPayouts: "Levels and Payouts:",
    minPointsLabel: "Min. Points Required",
    payoutAmountLabel: "Payout Amount (ETB)",
    payoutInfoNote: "Payouts are processed based on reaching level thresholds. Terms and conditions apply.",
    shareYourLink: "Share your link",

    // New onboarding translations
    referralAndEarnings: 'Referral & Earnings',
    referralAndEarningsDesc: 'Share your referral links and earn points. Create social media posts of your items and track engagement.',
    socialMediaIntegration: 'Social Media Integration',
    socialMediaIntegrationDesc: 'Share your or others listings directly to social media platforms. When you share others listing, if the seller pays commision per shares, you will earn money depending on the social media engagement of your link. The seller can track views, likes, and orders in real-time.',
    bulkListing: 'Bulk Listing',
    bulkListingDesc: 'Use our seller dashboard to import your Excel inventories directly and create multiple listings in one go. The seller dashboard also enables you to manage your items and orders in an easy way',
    clickAndCollect: 'Click & Collect',
    clickAndCollectDesc: 'Use our convenient pickup locations to collect your purchased items. Choose a safe and secure collection points near you.',
    getStarted: 'Get Started',
    exploreNewFeatures: 'Explore New Features',

    // Sharing and Preview translations
    sharing: "Sharing...",
    postToSocials: "Post to Socials",
    openInApp: "Open in App",
    itemSharedSuccessfully: "Item shared successfully",
    linkCopiedToClipboard: "Link copied to clipboard",
    failedToShareItem: "Failed to share item",
    loginRequiredToShare: "Please log in to share items",
    shareItemTitle: "Check out {{itemName}} on Warka",
    shareItemText: "I found {{itemName}} from {{storeName}} on Warka",
    error: "Error",
    itemNotFound: "Item not found",
    branchLinkCopied: "Branch link copied to console (development mode)",
    sharePreview: "Share on Social Media",
    directMessageLink: "Direct Message Link",
    postLink: "Post Link",
    contactOptions: "Contact Options",
    hideListing: 'Hide Listing',
    hideListingInfo: 'Hide this listing from the marketplace if the item is out of stock or if you don\'t want to show it',
    hidden: "Hidden",
    bonusAmountLabel: "Bonus",
    payoutInfoNote1: "Payouts are processed based on reaching level thresholds.",
    payoutInfoNote2: "Only active users, sellers, and service providers are considered for payouts. The system will verify account activity.",
    payoutInfoNote3: "Please read our terms and conditions for complete details about payout eligibility and processing.",
    copyOGImage: 'Copy post image link',
    copyPreviewLink: 'Copy Preview Link',
    previewLinkCopied: 'Preview link copied to clipboard',
    failedToCopy: 'Failed to copy',
    failedToGeneratePreview: 'Failed to generate preview',
    generatingLinks: 'Generating links...',
    copyBranchUrl: 'Copy product link',
    branchUrlCopied: 'Product link copied to clipboard',
    failedToGenerateBranchUrl: 'Failed to generate product link',
    ogImageUrlCopied: 'Image link is copied',
  
    appointments: 'Appointments',

    whatsappVerificationRequired: 'Phone registration requires verification through WhatsApp. A verification code will be sent to your WhatsApp number.',
    whatsappVerificationInfo: 'You will receive a verification code on WhatsApp. Make sure you have WhatsApp installed and can receive messages.',
    whatsappLoginInfo: 'You will receive a verification code on WhatsApp. Make sure you have WhatsApp installed and can receive messages.',
    whatsappOtpSent: 'Please check WhatsApp for your verification code',
    telegramVerificationRequired: 'Phone registration requires verification through Telegram. A verification code will be sent to your Telegram account.',
    telegramVerificationInfo: 'You will receive a verification code on Telegram. Make sure you have Telegram installed and can receive messages.',
    telegramLoginInfo: 'You will receive a verification code on Telegram. Make sure you have Telegram installed and can receive messages.',
    telegramOtpSent: 'Please check Telegram for your verification code',
    emailVerificationRequired: 'Important: You will not be able to log in until you verify your email address by clicking the link we sent.',
    bookings: 'Booking',
    other: 'Others',
    noNotifications: 'No notifications',
    markAllAsRead: 'Mark all as read',
    unread: 'unread',

    selectDateAndTime: "Select Date and Time"

  },
  am: {
    // Amharic translations
    // Account Center
    // Account Center Additional Translations
    selectDateAndTime: "ቀን እና ሰአት ይምረጡ",
    noNotifications: 'ማስታወሻዎች የሉም',
    markAllAsRead: 'ሁሉንም እንደተነበበ ምልክት አድርግ',
    unread: 'ያልተነበቡ',
    bookings: 'ቀጠሮዎች',
    other: 'ሌሎች',
    appointments: 'ቀጠሮዎች',
    notifications: 'ማስታወሻዎች',
    bookNow: 'ቀጠሮ ያዝ',
    bonusAmountLabel: "ተጨማሪ ቦነስ",
    hidden: "የተደበቀ",
    contactOptions: "የመገናኛ መንገዶች",
    activate: "Activate",
    activateProviderConfirmation: "የአገልግሎት አቅራቢ ገጽዎን activate ለማድረግ እርግጠኛ ነዎት? አገልግሎትዎ በአገልግሎቶች ገጽ ይታያል።",
    activateSellerConfirmation: "የሻጭ ገጽዎን activate ለማድረግ እርግጠኛ ነዎት? እቃዎችዎ በገበያ ውስጥ ይታያሉ።",
    confirmActivate: "አረጋግጥ",
    active: "ይታያል",
    providerProfileInfo: "የአገልግሎት አቅራቢ ገጽዎ ለሌሎች ይታያል። አገልግሎቶችዎን ለመደበቅ Deactivate ያድርጉት።",
    sellerProfileInfo: "የሻጭ ገጽዎ ለሌሎች ይታያል። ዕቃዎችዎን ለመደበቅ Deactivate ያድርጉት።",
    providerProfileDeactivatedInfo: "የአገልግሎት አቅራቢ ገጽዎ አሁን ተዘግቷል። አገልግሎቶችዎን ለማሳየት Activate ያድርጉት።",
    sellerProfileDeactivatedInfo: "የሻጭ ገጽዎ አሁን ተዘግቷል። ዕቃዎችዎን ለማሳየት Activate ያድርጉት።",
    deleteAccountPoint1: "ሁሉም የገጽ መረጃዎች",
    deleteAccountPoint2: "ያዘጋጁዋቸው ዕቃዎች እና አገልግሎቶች",
    deleteAccountPoint3: "የተላኩ መልክቶች እና ግንኙነቶች",
    deleteAccountPoint4: "ሁሉም የግብይት ታሪኮች",
    profileManagementInfo: "የገጽ አስተዳደር የአካውንትዎ ገጽታዎች እንዴት እንደሚታዩ እንዲቆጣጠሩ ያስችልዎታል። ገጽን ማጥፋት ከሌሎች መደበቅ ይችላሉ፡፡ አክቲቭ ማድረግ ሲፈልጉ የተቀመጠዉን መረጃ ያገኛሉ።",
    dangerZoneWarning: "በዚህ ክፍል ውስጥ ያሉት እርምጃዎች በአካውንትዎ እና በመረጃዎች ላይ ጎጂ ተፅእኖ ሊያሳድሩ ይችላሉ። እባክዎ በጥንቃቄ ይቀጥሉ እና ውጤቶቹን መረዳትዎን ያረጋግጡ።",
    accountCenter: "የአካውንት አስተዳደር",
    manageProfiles: "ገጾችን ያስተዳድሩ",
    providerProfile: "የአገልግሎት ገጽ",
    sellerProfile: "የሻጭ ገጽ",
    deactivate: "Deactivate",
    deactivateProviderConfirmation: "የአገልግሎትዎን ገጽ ማጥፋት እርግጠኛ ነዎት? ከአገልግሎት ፍለጋ ገጽ ይደበቃል።",
    deactivateSellerConfirmation: "የሻጭ ገጽዎን ማጥፋት እርግጠኛ ነዎት? ዕቃዎችዎ ከገበያ ይደበቃሉ።",
    confirmDeactivate: "አረጋግጥ",
    processing: "በሂደት ላይ...",
    noProfilesToManage: "ምንም ተጨማሪ ገጽዎች የሎትም።",
    dangerZone: "ጥንቃቄ ዞን",
    deleteAccount: "አካውንት ሰርዝ",
    deleteAccountWarning: "ማስጠንቀቂያ፦ ይህ ድርጊት ሊቀለበስ አይችልም!",
    deleteAccountConfirmation: "አካውንትዎን መሰረዝ ሁሉንም መረጃዎችዎን፣ ገጽዎችዎን፣ እና ዕቃዎችን ይሰርዛል።",
    confirmDelete: "መሰረዙን አረጋግጥ",
    providerProfileDeactivated: "የአገልግሎት ገጽዎ ተዘግቷል",
    sellerProfileDeactivated: "የሻጭ ገጽዎ ተዘግቷል",
    errorDeactivatingProfile: "ገጽን ማዘግት አልተሳካም",
    accountDeletionRequested: "የአካውንት መሰረዝ ተጠይቋል። በቅርብ ጊዜ ይገናኙዎታል።",
    errorDeletingAccount: "የአካውንት መሰረዝ ጥያቄ ማስገባት አልተሳካም",
    addedToCart: "ወደ ግዢ ተጨምረዋል",
    enterEmailInstructions: "የይለፍ ቃል መቀየሪያ ሊንክ ለመቀበል የኢሜይል አድራሻዎን ያስገቡ።",
    sendResetLink: "የይለፍ ቃል መቀየሪያ ሊንክ ይላኩ",
    resetLinkSent: "የይለፍ ቃል መቀየሪያ ሊንክ ተልኳል!",
    checkEmailForInstructions: "ለተጨማሪ መመሪያዎች ኢሜይልዎን ይመልከቱ።",
    passwordResetComplete: "የይለፍ ቃል መቀየር ተጠናቋል!",
    createNewPassword: "አዲስ የይለፍ ቃል ይፍጠሩ",
    redirectingToLogin: "ወደ መግቢያ ገጽ በመቀየር ላይ...",
    enterNewPasswordBelow: "ከዚህ በታች አዲሱን የይለፍ ቃል ያስገቡ።",
    newPassword: "አዲስ የይለፍ ቃል",
    updating: "በመቀየር ላይ...",
    passwordResetSuccess: "የይለፍ ቃል መቀየር ተሳክቷል!",
    youCanNowLogin: "አሁን በአዲሱ የይለፍ ቃልዎ መግባት ይችላሉ።",
    invalidOrExpiredResetLink: "ይህ የይለፍ ቃል መቀየሪያ ሊንክ ጊዜው ያለፈበት ወይም ትክክል አይደለም።",
    passwordResetError: "የይለፍ ቃል መቀየር አልተሳካም።",
    backToHome: "ወደ መነሻ ገጽ",
    signIn: "ይግቡ",
    dontHaveAccount: "አካውንት የለዎትም?",
    createAccount: "አካውንት ይፍጠሩ",
    loginWithEmail: "በኢሜይል ይግቡ",
    loginWithPhone: "በስልክ ይግቡ",
    loginWithWhatsApp: "በWhatsApp ይግቡ",
    loginWithTelegram: "በTelegram ይግቡ",
    loginWithGoogle: "በGoogle ይግቡ",
    loginWithFacebook: "በFacebook ይግቡ",
    back: "ተመለስ",
    email: "ኢሜይል",
    required: "ያስፈልጋል",
    invalidEmail: "ትክክል ያልሆነ የኢሜይል አድራሻ",
    password: "የይለፍ ቃል",
    forgotPassword: "የይለፍ ቃል ረሱ?",
    signingIn: "በማስገባት ላይ...",
    phoneNumber: "ስልክ ቁጥር",
    sending: "በመላክ ላይ...",
    sendOTP: "የማረጋገጫ ኮድ ይጠይቁ",
    verificationCode: "የማረጋገጫ ኮድ",
    verifying: "በማረጋገጥ ላይ...",
    verifyOTP: "የተላከዉን ኮድ በማስገባት ያረጋግጡ",
    loginSuccess: "መግባት ተሳክቷል!",
    invalidPhoneNumber: "ስልክ ቁጥሩ ትክክል አይደለም",
    otpSent: "የማረጋገጫ ኮድ በተሳካ ሁኔታ ተልኳል!",
    createYourAccount: "አካውንት ይፍጠሩ",
    registerWithEmail: "በኢሜይል ይመዝገቡ",
    registerWithPhone: "በስልክ ይመዝገቡ",
    registerWithTelegram: "በTelegram ይመዝገቡ",
    registerWithGoogle: "በGoogle ይመዝገቡ",
    registerWithFacebook: "በFacebook ይመዝገቡ",
    fullName: "ሙሉ ስም",
    optional: "አማራጭ",
    confirmPassword: "የይለፍ ቃል በድጋሜ በማስገባት ያረጋግጡ",
    register: "ይመዝገቡ",
    verifyAndRegister: "ኮዱን ያረጋግጡ እና ይመዝገቡ",
    otpSentInfo: "የማረጋገጫ ኮድ ወደ ስልክዎ ተልኳል",
    examplePhoneFormat: "ለምሳሌ: +251(Ethiopia) ከመረጡ በ 09 ወይም በ 07 የሚጀምር ስልክ ቁጥር ያስገቡ",
    //examplePhoneFormat: "በኢትዮጵያ ስልክ ቁጥር መመዝገብ/መግባት ለጊዜው አልተፈቀደም። ይህንን አገልግሎት በቅርብ ጊዜ እናስጀምራለን!",
    // "ለምሳሌ: +251912345678",
    tooShort: "በጣም አጭር",
    tooLong: "በጣም ረጅም",

    verificationSuccess: "ማረጋገጫው ተሳክቷል",
    emailNotConfirmed: "ኢሜል አልተረጋገጠም",
    invalidCredentials: "ትክክል ያልሆነ ኢሜይል ወይም የይለፍ ቃል",
    userAlreadyExists: "በዚህ ኢሜይል አስቀድሞ የተመዘገበ አካውንት አለ",
    passwordTooShort: "የይለፍ ቃል ቢያንስ 6 ፊደላት መሆን አለበት",
    invalidPhoneFormat: "እባክዎ ትክክለኛ ስልክ ቁጥር ያስገቡ (ለምሳሌ፡ 912345678)",
    invalidOTP: "የማረጋገጫ ኮድ ትክክል አይደለም። እባክዎ እንደገና ይሞክሩ።",
    inCart: "ወደ ግዢ ሳጥን ተጨምረዋል",
    addToCart: "ወደ ግዢ ሳጥን ጨምር",
    goToCart: "ወደ ግዢ ሳጥን ሂድ",
    addAllToCart: "ሁሉንም ወደ ግዢ ሳጥን ጨምር",
    adding: "በመጨመር ላይ...",
    unsaveAll: "ሁሉንም አስወግድ",
    removing: "በማስወገድ ላይ...",
    noItemsToAdd: "ወደ ግዢ ሳጥን የሚጨመሩ እቃዎች የሉም",
    allItemsAddedToCart: "ሁሉም እቃዎች ወደ ግዢ ሳጥን ተጨምረዋል",
    failedToAddItems: "እቃዎች ወደ ግዢ ሳጥን መጨመር አልተሳካም",
    noSavedItemsToRemove: "ምንም የተቀመጡ እቃዎች ሊሰወጡ የሉም",
    noSavedProvidersToRemove: "ምንም የተቀመጡ አገልግሎት አቅራቢዎች ሊሰወጡ የሉም",
    allItemsUnsaved: "ሁሉም እቃዎች ከተቀመጡ ተወግደዋል",
    allProvidersUnsaved: "All service providers have been unsaved",
    failedToUnsaveItems: "Failed to remove saved items",
    changeRole: "ይቀይሩ",
    keyFeatures: "ዋና ገጽዎች",
    shopperTitle: "ይፈልጉ ፡ ይግዙ",
    shopperDesc: "ዕቃዎችዎን ይግዙ",
    shopperFeature1: "ዕቃዎችዎን አይነት እና ዋጋ በማስገባት ይፈልጉ",
    shopperFeature2: "ከሻጮች ጋር በቀጥታ ይወያዩ",
    shopperFeature3: "በቅርብ ያሉ መውሰጃ ቦታዎችን ይምረጡ",
    shopperFeature4: "ለገዙት እቃ አስተያየት እና ደረጃ ያስቀምጡ",

    sellerTitle: "ዕቃዎችዎን ይሽጡ",
    sellerDesc: "የሻጭ ገጽ ይፍጠሩ፣ ከገዢዎች ጋር ይገናኙ እና ንግድዎን በአካባቢው ያሳድጉ።",
    sellerFeature1: "የእቃዉን ምስል፤ ስም እና ዝርዝር መረጃ ያስገቡ",
    sellerFeature2: "ዋጋ እና ቅናሾች በማስቀመጥ ገዢ ይሳቡ",
    sellerFeature3: "እስከ 10 የመውሰጃ ቦታዎችን ያመቻቹ",
    sellerFeature4: "ከገዢዎች ጋር በቀጥታ ይገናኙ",

    providerTitle: "አገልግሎቶችዎን ያቅርቡ",
    providerDesc: "የአገልግሎት ገጽ ይፍጠሩ፣ ከደንበኞች ጋር ይገናኙ እና ንግድዎን ያሳድጉ።",
    providerFeature1: "አገልግሎትዎን ያስተዋዉቁ",
    providerFeature2: "ሙያዎን የሚያሳዩ ምስሎችን ያስገቡ",
    providerFeature3: "ፖርትፎሊዮዎን እና አድራሻዎን ያሳዩ",
    providerFeature4: "በአካባቢው ካሉ ደንበኞች ጋር ይገናኙ",

    seekerTitle: "አካባቢያዊ አገልግሎቶችን ያግኙ",
    seekerDesc: "ለሚፈልጉት ማንኛውም አገልግሎት በአካባቢዎ ያሉ ባለሙያዎችን ያግኙ።",
    seekerFeature1: "የአገልግሎት አይነት እና አካባቢ በማስገባት ይፈልጉ",
    seekerFeature2: "የአቅራቢ ፖርትፎሊዮዎችን እና የሌሎች ደንበኞች አስተያየት ይመልከቱ",
    seekerFeature3: "ከአገልግሎት ሰጭው ጋር በቀጥታ ይገናኙ",
    seekerFeature4: "ላገኙት አገልግሎት አስተያየት ያስቀምጡ",

    travelerTitle: "ተጓዦች",
    travelerDesc: "የጉዞ ዕቅዶችዎን ያጋሩ፣ ከእቃ ላኪዎች ጋር ይገናኙ እና እቃዎችን በማድረስ ገንዘብ ያግኙ።",
    travelerFeature1: "የጉዞ መርሃ ግብርዎን ይለጥፉ",
    travelerFeature2: "ምን ያክል መጠን እና ክብደት ያለዉ እቃ መዉሰድ እንደሚችሉ ይግለጹ",
    travelerFeature3: "ከላኪዎች ጋር ይገናኙ",
    travelerFeature4: "እቃዎችን በማድረስ ተጨማሪ ገንዘብ ያግኙ",

    senderTitle: "በአለም አቀፍ ደረጃ እቃዎችን ይላኩ",
    senderDesc: "ወደሚፈልጉት መዳረሻ የሚሄዱ ተጓዦችን ያግኙ እና እቃዎችን በደህና እና በተመጣጣኝ ዋጋ ይላኩ።",
    senderFeature1: "ወደሚፈልጉት መዳረሻ የሚሄዱ ተጓዦችን ያግኙ",
    senderFeature2: "የእቃ አቅርቦትን ያዘጋጁ",
    senderFeature3: "እቃዎችዎን ይከታተሉ",
    senderFeature4: "ለተጓዦችን አስተያየት እና ደረጃ ይስጡ",
    whatWouldYouLikeToDo: "ይግዙ፣ ይሽጡ፣ አገልግሎቶችን ያግኙ፣ አገልግሎቶችን ይስጡ። ሁሉም በአንድ ቦታ!",
    imAShopper: "ገዢ ነኝ",
    imASeller: "ሻጭ ነኝ",
    imAServiceProvider: "አገልግሎት አቅራቢ ነኝ",
    imLookingForServices: "አገልግሎቶችን እፈልጋለሁ",
    imATraveler: "እቃዎችን መዉሰድ እፈልጋለሁ",
    iWantToSendItems: "እቃዎችን መላክ እፈልጋለሁ",
    letsGetYouSetUp: "እንመዝግብዎ! 📝",
    shopperSetupDesc: "የገዢ አካዉንትዎን ለመፍጠር ይቀጥሉ። በኢሜል ወይም በስልክ ቁጥርዎ ይመዝገቡ።",
    sellerSetupDesc: "የሻጭ አካዉንትዎን ለመፍጠር ይቀጥሉ። በኢሜል ወይም በስልክ ቁጥርዎ ይመዝገቡ።",
    providerSetupDesc: "የአገልግሎት አቅራቢ አካዉንትዎን ለመፍጠር ይቀጥሉ። በኢሜል ወይም በስልክ ቁጥርዎ ይመዝገቡ።",
    seekerSetupDesc: "የተጠቃሚ አካዉንትዎን ለመፍጠር ይቀጥሉ። በኢሜል ወይም በስልክ ቁጥርዎ ይመዝገቡ።",
    travelerSetupDesc: "የተጓዥ አካዉንትዎን ለመፍጠር ይቀጥሉ። በኢሜል ወይም በስልክ ቁጥርዎ ይመዝገቡ።",
    senderSetupDesc: "የላኪ አካዉንትዎን ለመፍጠር ይቀጥሉ። በኢሜል ወይም በስልክ ቁጥርዎ ይመዝገቡ።",
    setupDesc: "ለመቀጠል አካዉንትዎን ይፍጠሩ። በኢሜል ወይም በስልክ ቁጥርዎ ይመዝገቡ።",
    completeYourProfile: "ገጽዎን ያጠናቅቁ 🚀",
    sellerProfilePrompt: "የሻጭ ገጽዎን ይፍጠሩ፣ ዕቃዎችን ያክሉ እና መውሰጃ ቦታዎችን ያስገቡ።",
    shopperProfilePrompt: "በአቅራቢያዎ ያሉ እቃዎችን ያግኙ፣ ከሻጮች ጋር ወዲያውኑ ይገናኙ።",
    serviceProviderPrompt: "የአገልግሎት ገጽዎን ይፍጠሩ እና ልምድዎን ይዘርዝሩ።",
    serviceSeekerPrompt: "አስተማማኝ ባለሙያዎችን ይፈልጉ እና ይገናኙ።",
    travelerProfilePrompt: "የተጓዥ ገጽ ይፍጠሩ፣ ጉዞዎችዎን እና ያለዎትን የጭነት ቦታ ያክሉ።",
    senderProfilePrompt: "በእርስዎ አቅጣጫ የሚሄዱ ተጓዦችን ያግኙ እና እቃዎችዎን በደህንነት ይላኩ።",
    defaultProfilePrompt: "ከዋርካ የተሻለ ተጠቃሚ ለመሆን ገጽዎን ያጠናቅቁ።",
    greatChoice: "ጥሩ ምርጫ!",
    shopperSetup: "የገዢ አካዉንትዎን እናዘጋጅ።",
    sellerSetup: "የሻጭ አካዉንትዎን እናዘጋጅ።",
    providerSetup: "የአገልግሎት አቅራቢ አካዉንትዎን እናዘጋጅ።",
    seekerSetup: "አገልግሎቶችን ለመፈለግ አካዉንትዎን እናዘጋጅ።",
    travelerSetup: "የተጓዥ አካዉንትዎን እናዘጋጅ።",
    senderSetup: "የላኪ አካዉንትዎን እናዘጋጅ።",
    wouldYouLikeToCreateProfile: "ገጽዎን አሁን መፍጠር ይፈልጋሉ?",
    yes: "አዎ",
    setupUserProfile: "የተጠቃሚ ገጽዎን ያዘጋጁ",
    userProfileDescription: "እንደ {{selectedPersona}}፣ መሰረታዊ የተጠቃሚ ገጽ ያስፈልግዎታል።",
    createBasicProfile: "መሰረታዊ ገጽ ይፍጠሩ",
    signupSuccessful: "ምዝገባ ተሳክቷል!",

    goToProfile: "ወደ ገጽዎ ይሂዱ",
    createAccountOrLogin: "አካውንት ይፍጠሩ / ይግቡ",
    onboardingStep1Title: "አካውንትዎን ይፍጠሩ 📝",
    onboardingStep1Desc: "በኢሜይል አድራሻዎ ወይም በስልክ ቁጥርዎ በቀላሉ ይመዝገቡ። ገጽዎን በቀላሉ ይፍጠሩ።",
    onboardingStep2Title: "ዕቃዎችን እና አገልግሎቶችን ይመዝግቡ 🛍️",
    onboardingStep2Desc: "ምርቶችን ፣ አገልግሎቶችን በቀላሉ ይፈልጉ። የሚፈልጉትን በፍጥነት እና በትክክል ለማግኘት የማጣሪያ መንገዶችን ይጠቀሙ።",
    onboardingStep3Title: "በልበ ሙሉነት ይግዙ ወይም ይሽጡ 🤝",
    onboardingStep3Desc: "ለመሸጥ እቃዎችን ይለጥፉ ወይም በቀጥታ በደህንነቱ በተጠበቀ የውይይት መስኮት ከሻጮች ጋር ይገናኙ። ምቹ የመውሰጃ ቦታዎችን ያዘጋጁ ወይም ማድረስ የሚችል ሰው ይፈልጉ።",
    onboardingStep4Title: "ይገናኙ እና ይተባበሩ ✨",
    onboardingStep4Desc: "በቀላሉ እና በደህንነት መልዕክት ይለዋወጡ። እንደ ዋጋ፣ መውሰጃ፣ ማድረሻ ወይም አገልግሎቶች ያሉ ዝርዝሮችን በቀጥታ በመተግበሪያው ውስጥ ያስተባብሩ።",
    welcomeToWarka: "ወደ ዋርካ እንኳን በደህና መጡ! 🎉",
    getStartedQuickly: "በእነዚህ ቀላል ደረጃዎች በፍጥነት ይጀምሩ:",
    step: "ደረጃ",
    imageComingSoon: "የማስተማሪያ ምስል እዚህ ይታያል",
    skip: "ዝለል",
    previous: "ተመለስ",
    next: "ቀጣይ",
    createNewAccount: "አዲስ አካዉንት ይፍጠሩ",
    alreadyHaveAccount: "አካዉንት አለዎት?",
    sellerPendingGuidance: "ትዕዛዙን ለመቀበል ዝግጁ ሲሆኑ እባክዎ ያረጋግጡ።",
    sellerConfirmedGuidance: "እቃውን ካዘጋጁ ገዢው እቃውን ለመውሰድ እንዲመጣ ዝግጁ መሆኑን ያመልክቱ።",
    sellerReadyGuidance: "ገዢው ስለ ዝግጁነቱ ተነግሮታል እና እቃውን ለመውሰድ መምጣት ይችላል።",
    sellerCompletedGuidance: "ይህ ትዕዛዝ ተጠናቋል። ስለ አገልግሎትዎ እናመሰግናለን!",
    buyerPendingGuidance: "እባክዎ የመውሰጃ ቦታ ይምረጡ እና ሻጩ እስኪያረጋግጥ ይጠብቁ።",
    buyerReadyGuidance: "እንኳን ደስ አለዎት! እቃዎን በመረጡበት ቦታ ላይ ለመውሰድ ዝግጁ ነው።",
    buyerConfirmedGuidance: "ትዕዛዝዎ ተረጋግጧል! ሻጩ እቃዎን እያዘጋጀ ነው።",
    buyerCompletedGuidance: "ትዕዛዝዎ ተጠናቋል። ስለ ግዢዎ እናመሰግናለን",
    statusInfo: "የግዢ መረጃ",
    deleteOrder: "ግዢ ሰርዝ",
    markReady: "እቃው ለመወሰድ ዝግጁ ነዉ",
    completeOrder: "ግዢ ተጠናቋል",
    contactInformation: "የመገናኛ መረጃ",
    contact: "መገናኛ",
    passwordsNotMatch:"የይለፍ ቃል አልተመሳሰለም",
    formattedCode: "ሪፈራል ቁጥር",
    referralCodeHelp: "ሪፈር የተደረጉበትን ተጠቃሚ ቁጥር ያስገቡ",
    referredByUser: "የሪፈራል ቁጥር አለዎት?",
    referralEarnings: "በሪፈራል የተገኘ ነጥብ",
    referralCode: "ሪፈር ያደረገዉ ተጠቃሚ ቁጥር",
    referralCodeCopied: "ሪፈራል ቁጥር ኮፒ ተደርጓል",
    regNumber: "የምዝገባ ቁጥር",
    helpSupport: "ተጨማሪ መረጃዎች",
    theme: "ገጽታ",
    themeMidnight: "እኩለ ሌሊት",
    themeDark: "ጨለማ",
    themeLight: "ብርሃን",
    tapToCreate: "Tap to create",
    account: "አካዉንት",
    home: "መነሻ",
    shop: "ገበያ",
    service: "አገልግሎቶች",
    chat: "ቻት",
    profile: "የግል ገጽ",
    createProviderProfile: "የአገልግሎት ሰጭ ገጽ ፍጠር",
    createSellerProfile: "የሻጭ ገጽ ፍጠር",
    sellerProfileNeeded: "የሻጭ ገጽ ያስፈልጋል",
    sellerProfileNeededDesc: "ዕቃዎችን ለመሸጥ የሻጭ ገጽ ይፍጠሩ።",
    myProfiles: "የእኔ ገጾች",
    noPickupLocations: "የእቃ መዉሰጃ ቦታዎች አልተቀመጡም",
    requiredField: "ይህ ያስፈልጋል",
    errorWrongCredentials: "ኢሜል ወይም የይለፍ ቃል ትክክል አይደለም",
    errorUserNotFound: "በዚህ ኢሜል የተመዘገበ አካውንት የለም። እባክዎ መጀመርያ ይመዝገቡ።",
    errorEmailExists: "በዚህ ኢሜል አስቀድሞ የተመዘገበ አካውንት አለ",
    errorInvalidEmail: "እባክዎ ትክክለኛ የኢሜል አድራሻ ያስገቡ",
    errorTooManyAttempts: "በጣም ብዙ የተሳሳቱ ሙከራዎች። እባክዎ ቆይተው እንደገና ይሞክሩ",
    errorWeakPassword: "የይለፍ ቃል ቢያንስ 6 ፊደላት መሆን አለበት",
    errorPopupClosed: "ምዝገባው ተሰርዟል",
    errorRequiresRecentLogin: "ይህን ተግባር ለማጠናቀቅ እባክዎ እንደገና ይግቡ",
    errorNetworkIssue: "የኔትወርክ ችግር። እባክዎ ግንኙነትዎን ያረጋግጡ",
    errorInvalidPhone: "ስልክ ቁጥሩ ትክክለኛ አይደለም",
    errorInvalidOTP: "የማረጋገጫ ኮድ ትክክል አይደለም",
    errorOTPExpired: "የማረጋገጫ ኮድ ጊዜው አልፎአል። እባክዎ አዲስ ይጠይቁ",
    errorMissingOTP: "እባክዎ የማረጋገጫ ኮዱን ያስገቡ",
    errorAuthGeneric: "የማረጋገጫ ስህተት። እባክዎ እንደገና ይሞክሩ",
    errorGeneric: "ስህተት ተከስቷል። እባክዎ እንደገና ይሞክሩ",
    selectLocation: "ቦታ ይምረጡ",
    noPickupLocationsAvailable: "ሻጩ የእቃ መዉሰጃ ቦታ አላስቀመጠም፡ እባክዎ ከሻጩ ጋር ይነጋገሩ",
    customLabel: "",
    displayNameHelp: "ደንበኞች የሚያዩት አድራሻ ይህን ይመስላል",
    editDisplayName: "የቦታ ስም ያስገቡ",
    businessNameCity: "የድርጅት ስም, ከተማ",
    recentlyViewed: "በቅርቡ የታዩ",
    newlyAdded: "አዲስ የገቡ",
    loginRequiredforTravel: "የጉዞዎች መረጃዎች ለማስገባት መመዝግብ ይኖርበዎታል",
    exploreOurServices: "የምንሰጣቸዉ አገልግሎቶች",
    marketplace: "ዋርካ ገበያ",
    buyAndSellItems: "ዕቃዎችን ይግዙ/ይሽጡ",
    findOrOfferServices: "አገልግሎቶችን ያግኙ/ያቅርቡ",
    findTravellers: "ተጓዦች እና ላኪዎች",
    sendItemsWithTravellers: "ከተጓዦች ጋር ዕቃዎችን ይላኩ",
    findOrPostJobs: "ክፍት የሥራ ቦታዎችን ያግኙ/ያስተዋዉቁ",
    discoverLocalEvents: "የመዝናኛ ዝግጅቶችን እና ቲኬቶችን ያግኙ",
    findRealEstate: "ቤቶች እና ንብረቶች",
    browseProperties: "ቤት እና ንብረቶችን ይግዙ/ይሽጡ",
    advertiseYourServicesOnline: "የአገልግሎት ማስታወቂያ ገጽ ይክፈቱ",
    startSellingOnline: "የሽያጭ ገጽ ይክፈቱ",
    scanToPickUp: "እቃ ለመዉሰድ ስካን ያድርጉ",
    selectPickupLocation: "የእቃ መዉሰጃ ቦታዎችን ይምረጡ",
    orderNow: "አሁን ይግዙ",
    orders: "ግዢ እና ትእዛዞች",
    addLocation: "አድራሻ ይጨምሩ",
    selectCategoryFirst: "የእቃ ምድብ መጀመሪያ ይምረጡ",
    selectSubcategory: "ዝርዝር አይነት ይምረጡ",
    subcategory: "ዝርዝር አይነት",
    pickupLocations: "የእቃ መዉሰጃ ቦታዎች",
    addPickupLocation: "የእቃ መዉሰጃ ቦታዎችን ይጨምሩ",
    selected: "የተመረጡ",
    noneSelected: "የተመረጡ የሉም",
    selectServiceLocations: "የአገልግሎት ከተሞች ይምረጡ",
    editProviderProfile: "የአገልግሎት መረጃን ይፍጠሩ",
    serviceCategory: "የአገልግሎት አይነት",
    buisnessLocation: "የድርጅቱ አድራሻ",
    selectedServices: "የተመረጡ አገልግሎቶች",
    Saving: "በመጫን ላይ...",

    messageSentSuccess: "መልክትዎ ተልኳል",
    messageSentError: "መልክትዎን መላክ አልተሳካም",
    providerRemovedFromSaved: "አገልግሎቱ ከተመረጡ አገልግሎቶች ተወግዷል",
    providerRemoveError: "አገልግሎቱ ከተመረጡ አገልግሎቶች አልተወገደም",
    providerSavedSuccess: "አገልግሎት ተመርጧል",
    providerSaveError: "አገልግሎት መምረጥ አልተቻለም ወይም በድጋሚ ተመርጧል",
    savedItems: "የተመረጡ",
    savedItemsTab: "የተመረጡ እቃዎች",
    savedServicesTab: "የተመረጡ አገልግሎቶች",
    noSavedProvidersFound: "የተመረጡ አገልግሎቶች አልተገኙም",
    pleaseLogInToViewSavedItems: "እባክዎ የተመረጡ እቃዎች ለማየት ይግቡ",
    loadingSavedItems: "የተመረጡ እቃዎች በመጫን ላይ...",
    noSavedItemsFound: "ምንም የተመረጡ እቃዎች አልተገኙም",
    savedItemsServices: "የተመረጡ እቃዎች እና አገልግሎቶች",
    itemSavedSuccess: "እቃዉ ተመርጧል",
    itemSaveError: "እቃዉ አልተመረጠም ወይም በድጋሚ ተመርጧል",
    itemRemovedFromSaved: "እቃዉ ከተመረጡ እቃዎች ተወግዷል",
    itemRemoveErrorSaved: "እቃዉ ከተመረጡ እቃዎች አልተወገደም",
    phone: "ስልክ",
    sendResetEmail: "የይለፍ ቃል ለመቀየር ኢሜል ላክ",
    backToLogin: "ወደ መግቢያ ተመለስ",
    itemDetails: "የእቃዉ መረጃ",
    seller: "ሻጭ",
    viewStore: "ገጻችንን ይመልከቱ",
    customerReviews: "የደንበኞች አስተያየት",
    signInWithGoogle: "በጉግል ይግቡ",
    signupWithGoogle: "በጉግል ይመዝገቡ",
    providerPage: "አገልግሎት ሰጭ ገጽ",
    sellerPage: "ሻጭ ገጽ",
    regularUser: "ተጠቃሚ ገጽ",
    city: "ከተማ",
    seeMoreFromSeller: "የሱቅ ገጻችንን ይጎብኙ",
    profileUpdateSuccess: "የገጽ መሻሻያ ተሳክቷል",
    profileUpdateFailure: "የገጽ መሻሻያ አልተሳካም",
    itemDescription: "የእቃዉ መግለጫ",
    noBanner: "ባነር የለም",
    onSale: "ቅናሽ ዋጋ",
    new: "አዲስ",
    soldOut: "አልቋል",
    limitedStock: "አነስተኛ አቅርቦት",
    sponsored: "ተደጋግፎ የተያዘ",
    editItem: "አስተካክል",
    updateItem: "ለዉጥ መዝግብ",
    uploadImages: "ምስል አስገባ",
    allServices: "ሁሉንም አገልግሎቶች",
    allCities: "ሁሉንም ከተሞች",
    appName: "ዋርካ",
    menu: "ምርጫ",
    moreLinks: "ሊንኮች",
    oldPrice: "ዋጋ",
    newPrice: "ቅናሽ ዋጋ",
    available: "ብዛት አለ",
    messages: "መልእክቶች",
    startChat: "ቻት ክፈት",
    loginToChat: "ለመወያየት ይግቡ",
    typeMessage: "መልእክት ይጻፉ...",
    noConversations: "ዉይይቶችን ምረጥ",
    startNewChat: "ከአገልግሎት ሰጪ ወይም ሻጭ ጋር አዲስ ውይይት ይጀምሩ",
    send: "ላክ",
    chatWith: "ከ{{name}} ጋር ይወያዩ",
    messageSent: "መልእክት ተልኳል",
    messageError: "መልእክት መላክ አልተሳካም",
    loadingMessages: "መልእክቶችን በመጫን ላይ...",
    chatHistory: "የውይይት ታሪክ",
    newMessage: "አዲስ መልእክት",
    unreadMessages: "ያልተነበቡ መልእክቶች",
    lastActive: "መጨረሻ የነበሩት {{time}} በፊት",
    online: "በመስመር ላይ",
    offline: "ከመስመር ውጪ",
    loginError: "መግባት አልተሳካም",
    signupSuccess: "በተሳካ ሁኔታ ተመዝግበዋል",
    signupError: "መመዝገብ አልተሳካም",
    logoutSuccess: "በተሳካ ሁኔታ ወጥተዋል",
    switchProfile: "ገጽ አይነት ቀይር",
    switchToProvider: "ወደ አገልግሎት አቅራቢ ገጽ ቀይር",
    profileSwitchSuccess: "በተሳካ ሁኔታ ገጽ ተቀይሯል",
    profileSwitchError: "ወደ መቀየር አልተሳካም",
    switchToSeller: "ወደ ሻጭ ገጽ ቀይር",
    switchToSellerSuccess: "በተሳካ ሁኔታ ወደ ሻጭ ገጽ ተቀይሯል",
    switchToSellerError: "ወደ ሻጭ ገጽ መቀየር አልተሳካም",
    switchToUser: "ወደ ተጠቃሚ ገጽ ቀይር",
    switchToUserSuccess: "በተሳካ ሁኔታ ወደ ተጠቃሚ ገጽ ተቀይሯል",
    switchToUserError: "ወደ ተጠቃሚ ገጽ መቀየር አልተሳካም",
    userNotFound: "ተጠቃሚውን ማግኘት አልተቻለም። እባክዎ መረጃዎትን ያረጋግጡ።",
    networkError: "የኔትወርክ ስህተት። እባክዎ የኢንተርኔት ግንኙነትዎን ያረጋግጡ።",
    infoNotFound: "የተጠየቀው መረጃ አልተገኘም።",
    incorrectPassword: "የተሳሳተ የይለፍ ቃል። እባክዎ እንደገና ይሞክሩ።",
    noAccountFound: "በዚህ መረጃ የተከፈተ ገጽ አልተገኘም።",
    failedToLogin: "ወደ ገጵዎ መግባት አልተሳካም",
    signInToYourAccount: "ወደ ገጵዎ ይግቡ",
    or: "ወይም",
    pleaseProvideEmailOrPhone: "እባክዎን ኢሜል ወይም ስልክ ቁጥር ያቀርቡ",
    accountCreated: "አካዉንትዎ በተሳካ ሁኔታ ተፈጥሯል! አሁን መግባት ይችላሉ።",
    failedToCreateAccount: "አካዉንት መፍጠር አልተሳካም",
    fullNameMinLength: "ሙሉ ስም ቢያንስ 2 ፊደሎች መሆን አለበት",
    enterFullName: "ሙሉ ስምዎን ያስገቡ",
    businessNameOptional: "የንግድ ስም (ካለ)",
    enterBusinessName: "የንግድ ስምዎን ያስገቡ (ካለ)",
    emailRequiredIfPhoneNotProvided: "ኢሜል አድራሻ (ስልክ ቁጥር ካላስገቡ ያስፈልጋል)",
    phoneRequiredIfEmailNotProvided: "ስልክ ቁጥር (ኢሜል አድራሻ ካላስገቡ ያስፈልጋል)",
    passwordRequired: "የይለፍ ቃል ያስፈልጋል",
    passwordMinLength: "የይለፍ ቃል ቢያንስ 6 ፊደሎች መሆን አለበት",
    confirmPasswordRequired: "እባክዎ የይለፍ ቃልዎን በትክክል ይድገሙ",
    passwordsDoNotMatch: "የይለፍ ቃሎች አይመሳሰሉም",
    creatingAccount: "አካዉንት በመፍጠር ላይ...",
    signUp: "ይመዝገቡ",
    pleaseSaveProfile: "እባክዎን የገጽዎን መረጃ ያስቀምጡ ከዚያ በኋላ የስራ ማሳያ ምስሎችን ይጨምሩ",
    dropImageHere: "ምስሉን እዚህ ያስገቡ",
    dragDropOrClick: "ምስል ይጎትቱና ያስገቡ ወይም ለመምረጥ ይጫኑ",
    maxFileSize: "ከፍተኛ የፋይል መጠን: 5MB",
    uploading: "በመጫን ላይ...",
    featuredProviders: "የተመርጡ አቅራቢዎች",
    contactViaWhatsApp: "በWhatsApp ያግኙ",
    contactViaTelegram: "በTelegram ያግኙ",
    callProvider: "{{phone}} ላይ ይደውሉ",
    noContactMethods: "ስልክ አልተገኘም",
    contactProvider: "{{providerName}}ን በዚህ ያግኙ",
    loginToViewContact: "እባክዎን መረጃ ለማየት እና ከዚህ አገልግሎት ሰጭ ጋር ለመገናኘት ይግቡ።",
    loginToContact: "የአገልግሎት ሰጭ ለማግኘት ይግቡ",
    reviewProvider: "ለ{{providerName}} አስተያየት ይስጡ",
    shareExperience: "ከአገልግሎት አቅራቢው ጋር ያለዎትን ልምድ ያካፍሉ",
    rating: "ደረጃ",
    serviceReceived: "የተሰጠው አገልግሎት",
    yourReview: "የእርስዎ አስተያየት",
    servicePlaceholder: "ለምሳሌ፡ የቧንቧ ጥገና፣ የቤት ጽዳት",
    experiencePlaceholder: "ልምድዎን ያካፍሉ...",
    loginRequired: "መጀመሪያ አካዉንትዎን ያስገቡ",
    ratingRequired: "እባክዎ ደረጃ ይምረጡ",
    serviceRequired: "እባክዎ አገልግሎቱን ይግለፁ",
    reviewRequired: "እባክዎ አስተያየት ይጻፉ",
    reviewSuccess: "አስተያየትዎን ተቀብለናል!",
    reviewFailed: "አስተያየት መስጠት አልተሳካም",
    cancel: "ተመለስ",
    cancelBack: "ተመለስ",
    cancelDiscard: "ሰርዝ",
    submitting: "በማስገባት ላይ...",
    failedToSubmitReview: "አስተያየት መስጠት አልተሳካም",
    submitReview: "አስተያየት አስገባ",
    reviewSubmitted: "አስተያየትዎን ተቀብለናል!",
    noImagesAvailable: "ምንም ፎቶዎች አልተገኙም",
    // Navigation & Common
    findServices: "አገልግሎቶች ፈልግ",
    buyItems: "እቃዎችን ግዛ",
    login: "ይግቡ",
    signup: "ይመዝገቡ",
    logout: "ውጣ",
    search: "ፈልግ",
    filter: "አጣራ",
    clearFilters: "ማጣሪያውን አጥፋ",
    clear: "አጥፋ",
    save: "አስቀምጥ",
    edit: "አስተካክል",
    delete: "ሰርዝ",
    loading: "በመጫን ላይ...",
    addImage: "ምስል አስገባ",
    saveChanges: "ለውጦችን መዝግብ",
    saving: "በማስቀመጥ ላይ...",
    about: "ስለ እኛ",
    editProfile: "አስተካክል",

    // Landing Page
    findProviders: "በአካባቢዎ ያሉ ባለሙያዎችን በቀላሉ ያግኙ",
    findProvidersSubtitle: "የታመኑ እና ጥራት ያላቸዉ አገልግሎቶች ባሉበት ሆነው ያግኙ",
    findSellers: "አዲስ እና ያገለገሉ እቃዎችን ይፈልጉ",
    findSellersSubtitle: "ከሻጮች ጋር በቀላሉ ይገናኙ",
    searchPlaceholder: "አገልግሎት ሰጪዎችን ይፈልጉ",
    cities: "ከተሞችን ይምረጡ",
    services: "አገልግሎት አቅራቢዎች",
    sortBy: "ቅደም ተከተል በ",
    reviews: "አስተያየቶች",
    noProviders: "ምንም አገልግሎት ሰጪዎች አልተገኙም",
    noProvidersDesc: "በዚህ አካባቢ የመጀመሪያው አገልግሎት ሰጪ ሆነዉ ይመዝገቡ",
    noProvidersFound: "ምንም አገልግሎት ሰጪዎች አልተገኙም",
    signUpAsProvider: "እንደ አገልግሎት ሰጪ ይመዝገቡ",
    anonymousProvider: "ያልታወቀ አገልግሎት ሰጪ",
    more: "ተጨማሪ",

        // New Translations
    findServicesAndShopItems: "አገልግሎቶችን እና የሚሸጡ እቃዎችን በቀላሉ ያገኛሉ",
    oneStopPlatform: "ሁሉንም አገልግሎቶች እና የሚሽጡ አዲስ እና ያገለገሉ እቃዎች በአንድ ቦታ እዚህ ያገኛሉ",
    findServicesOnly: "አገልግሎቶችን ይፈልጉ",
    shopItems: "የሚሽጡ እቃዎች",
    topServiceProviders: "የተመረጡ አገልግሎቶች",
    viewAll: "ሁሉንም እይ",
    latestItems: "የተመረጡ እቃዎች",
    searchItems: "የሚሽጡ እቃዎችን በስም ወይም በቁጥር ፈልግ",
    tryAdjustingFilters: "ማጣሪያዎችን ወይም የፍለጋ ቃላትን ይሞክሩ",
    noItemsFound: "ምንም የሚሽጡ እቃዎች አልተገኙም",
    allCategories: "ሁሉም ምድቦች",
    allConditions: "ሁሉም የእቃ ሁኔታዎች",
    minPrice: "አነስተኛ ዋጋ",
    maxPrice: "ከፍተኛ ዋጋ",

        //Routing page
    chooseYourRole: "ሚናዎን ይምረጡ፡ ተጠቃሚ ወይም አገልግሎት ሰጭ ወይም ሻጭ",
    getStartedBySelecting: "መድረክን እንዴት መጠቀም እንደሚፈልጉ በመምረጥ ይጀምሩ",
    signUpAsServiceProvider: "እንደ አገልግሎት አገልግሎት ሰጭ ይመዝገቡ",
    signUpAsSeller: "እንደ ሻጭ ይመዝገቡ",

        // Availability
    weekdays: "ከሰኞ እስከ አርብ",
    weekends: "ቅዳሜ እና እሁድ",
    evenings: "ማታ",
    emergency: "አስቸኳይ",
        // Categories
    homeServices: "የቤት አገልግሎቶች",
    technicalRepair: "ቴክኒካል ጥገና",
    personalServices: "የግል አገልግሎቶች",
    creativeServices: "የፈጠራ አገልግሎቶች",
    professionalServices: "ሙያዊ አገልግሎቶች",
    foodHospitality: "ምግብ እና እንግዳ ተቀባይነት",
    deliveryServices: "የማድረስ አገልግሎቶች",

        // Form Labels
    location: "አካባቢ",
    serviceLocations: "የአገልግሎት አካባቢዎች",
    shortDescription: "አጭር መግለጫ",
    serviceDetails: "የአገልግሎት ዝርዝሮች",
    servicesOffered: "የአገልግሎቶች አይነቶች",
    yearsExperience: "የልምድ ዓመታት",
    hourlyRate: "ክፍያ በሰአት(ብር)",
    availability: "የስራ ሰዓታት",
    contactInfo: "የመገናኛ መረጃ",
    whatsappNumber: "የዋትስአፕ ቁጥር",
    telegramUsername: "የቴሌግራም ተጠቃሚ ስም",
    messengerUsername: "የፌስቡክ ተጠቃሚ ስም",
    workGallery: "የስራ ማሳያ ፎቶዎች",
    profileImage: "የገጽ ምስል",
    basicInfo: "መሰረታዊ መረጃ",
    sellerInformation: "የሻጭ ድርጅት ስም",
    description: "መግለጫ",
    loginToContactSeller: "ከሻጭ ለመገናኘት ይግቡ",

        // Placeholders
    selectCity: "ከተማዎን ይምረጡ",
    shortDescriptionPlaceholder: "የአገልግሎትዎ አጭር መግለጫ",
    serviceDetailsPlaceholder: "የአገልግሎትዎ እና የልምድዎ ዝርዝር መግለጫ",
    whatsappPlaceholder: "ለምሳሌ፡ +251912345678",
    telegramPlaceholder: "ለምሳሌ፡ @username",
    messengerPlaceholder: "ለምሳሌ፡ username",
    phonePlaceholder: "ለምሳሌ፡ +251912345678",

        // Contact Methods
    contactViaMessenger: "በፌስቡክ ያግኙ",
    call: "ደውል",

    // Footer
    support: "ድጋፍ",
    contactUs: "አግኙን",
    helpCenter: "የእርዳታ ማዕከል",
    faq: "ተደጋጋሚ ጥያቄዎች",
    legal: "ሕጋዊ",
    privacyPolicy: "የግላዊነት ፖሊሲ",
    termsOfService: "የአገልግሎት ውሎች",
    cookiePolicy: "የኩኪ ፖሊሲ",
    connectWithUs: "ከእኛ ጋር ይገናኙ",
    allRightsReserved: "መብቱ በሕግ የተጠበቀ ነው",

    addItem: "እቃ መዝግብ",
    myItems: "የተመዘገቡ እቃዎች",
    storeProfile: "የንግድ ገጽ",
    storeImage: "የንግድ መግለጫ ምስል",
    storeName: "የንግድ ስም",
    businessName: "የንግድ ስም",
    storeDescription: "የንግድ ቦታ መግለጫ",
    startAdding: "እቃዎችን ወደ ሱቅዎ መጨመር ይጀምሩ",
    noItems: "ምንም እቃዎች የሉም",

    welcomeToYourStore: "እንኳን ወደ ሱቅዎ በደህና መጡ",
    manageYourItems: "እቃዎችዎን ይጨምሩ እና ከደንበኞች ጋር ይገናኙ",

    getInTouch: "ከኛ ጋር ይገናኙ",
    sendMessage: "መልእክት ይላኩልን",
    name: "ስም",
    message: "መልእክት",
    sendMessageButton: "መልእክት ላክ",

    // Help Center
    helpCenterTitle: "እርዳታ ማዕከል",
    gettingStartedTitle: "መጀመሪያ ደረጃ መረጃ",
    howToFindServiceProvider: "የአገልግሎት አቅራቢን እንዴት ማግኘት እችላለሁ?",
    howToFindServiceProviderDesc: "በsearch ወይም category በመምረጥ አገልግሎት አቅራቢዎችን ያግኙ። የእያንዳንዱን አቅራቢ ግምገማዎች፣ ደረጃ እና ዝርዝር መረጃ ይመልከቱ።",
    becomingServiceProvider: "እንደ አገልግሎት አቅራቢ መመዝገብ",
    becomingServiceProviderDesc: "አካዉንት ገጽ ይፍጠሩ፣ የአገልግሎት መረጃዎትን ይሙሉ፣ እና ከደንበኞች ጋር ይገናኙ።",

    commonIssuesTitle: "በተደጋጋሚ የሚጠየቁ ጥያቄዎች",
    accountManagementTitle: "አካዉንት አስተዳደር",
    resetPassword: "የይለፍ ቃል መቀየሪያ",
    updateProfileInfo: "የገጽ መረጃ ማስተካከል",
    managePrivacySettings: "የግላዊነት ማስተካከያዎች",

    serviceIssuesTitle: "የአገልግሎት ጥያቄዎች",
    contactServiceProvider: "ከአገልግሎት አቅራቢ ጋር መገናኘት",
    leaveReviews: "ግምገማ መስጠት",
    reportProblems: "ችግሮችን ሪፖርት ማድረግ",

    supportOptionsTitle: "የድጋፍ አማራጮች",
    supportDesc: "ተጨማሪ እርዳታ ከፈለጉ፡-",
    supportEmail: "ኢሜይል: support@warkashop.com",
    supportPhone: "ስልክ: +251 93 544 3037",
    supportChat: "ቀጥታ ውይይት (በቴሌግራም)",

    // FAQ
    faqTitle: "በተደጋጋሚ የሚጠየቁ ጥያቄዎች",
    faqQuestion1: "አገልግሎት አቅራቢን እንዴት ማግኘት እችላለሁ?",
    faqAnswer1: "በፍለጋ ሳጥን፣ ምድብ መምረጫ ወይም ማጣሪያዎች ያግኙ። የእያንዳንዱ አቅራቢ ግምገማዎችን እና ዝርዝር መረጃ ይመልከቱ።",
    faqQuestion2: "አገልግሎት አቅራቢ እንዴት መሆን እችላለሁ?",
    faqAnswer2: "አካዉንት ይፍጠሩ፣ የአገልግሎት አቅራቢ ገጽ ይምረጡ ፣ መረጃዎትን ይሙሉ፣ እና ከደንበኞች ጋር ይገናኙ።",
    faqQuestion3: "ክፍያ እንዴት ይሰራል?",
    faqAnswer3: "ክፍያዎች በቀጥታ በእርስዎ እና እና አቅራቢ መካከል ይከናወናሉ። በዚህ አፕ የክፍያ ዘዴዎችን ለመጠቀም ስራዎችን እየሰራን እንገኛለን።",
    faqQuestion4: "ግምገማ መስጠት እችላለሁ?",
    faqAnswer4: "አዎ፣ Login ካደረጉ ለማንኛውም አገልግሎት አቅራቢ ግምገማ መስጠት ይችላሉ።",
    faqQuestion5: "የአገልግሎት ችግር ካጋጠመኝ ምን ማድረግ አለብኝ?",
    faqAnswer5: "በመጀመሪያ ከአገልግሎት አቅራቢ ጋር ይነጋገሩ። ካልተሳካ የድጋፍ ቡድናችንን ያግኙ።",
    faqQuestion6: "የግል ገጽ መረጃ እንዴት ማስተካከል ይቻላል?",
    faqAnswer6: "ወደ ገጽዎ ይሂዱ እና 'ገጽ አስተካክል' የሚለውን ይጫኑ።",

    faqStillHaveQuestionsTitle: "አሁንም ጥያቄዎች አሉዎት?",
    faqStillHaveQuestionsDesc: "መልስ ያላገኙትን ጥያቄ ካለዎት እርዳታ ያግኙ።",
    faqContactSupport: "ከድጋፍ ቡድን ጋር ይገናኙ",

    // Privacy Policy
    privacyPolicyTitle: "የግላዊነት ፖሊሲ",
    infoCollectTitle: "የምንሰበስበው መረጃ",
    infoCollectDesc: "በቀጥታ ከእርስዎ የምንሰበስበው፡-",
    infoCollectItem1: "ስም እና አድራሻ",
    infoCollectItem2: "የገጽ ምርጫዎች",
    infoCollectItem3: "የክፍያ ታሪክ",
    infoCollectItem4: "የአገልግሎት መረጃ",

    howWeUseInfoTitle: "መረጃውን የምንጠቀምበት መንገድ",
    howWeUseInfoDesc: "መረጃውን ለሚከተሉት እንጠቀማለን፡-",
    howWeUseInfoItem1: "አገልግሎቶችን ለማሻሻል",
    howWeUseInfoItem2: "ከእርስዎ ጋር ለመገናኘት",
    howWeUseInfoItem3: "የደህንነት ማረጋገጫ ለማጠናከር",

    infoSharingTitle: "መረጃ መጋራት",
    infoSharingDesc: "መረጃዎን ከሚከተሉት ጋር እናጋራለን፡-",
    infoSharingItem1: "ሕጋዊ ድርጅቶች በሚጠይቁበት ጊዜ",
    infoSharingItem2: "አገልግሎት አቅራቢዎች",
    infoSharingItem3: "የደህንነት አስተዳደሮች",

    yourRightsTitle: "የእርስዎ መብቶች",
    yourRightsDesc: "ማድረግ የምትችሉት፡-",
    yourRightsItem1: "መረጃዎን ማስተካከል",
    yourRightsItem2: "ስህተቶችን ለማስተካከል",
    yourRightsItem3: "መረጃ ማስወገድ",
    yourRightsItem4: "ከማስታወቂያዎች መረጃዎን መሰረዝ",

    contactUsTitle: "አግኙን",
    contactUsDesc: "ለጥያቄዎች ወይም አስተያየቶች፡-",
    contactUsEmail: "support@warkashop.com",

    // Terms of Service
    termsTitle: "የአገልግሎት ውሎች",
    acceptanceTitle: "1. ውሎችን መቀበል",
    acceptanceDesc: "ይህን መተግበሪያ በመጠቀም የአገልግሎት ውሎችን እንደምትቀበሉ ያረጋግጣሉ።",

    userResponsibilitiesTitle: "2. ተጠቃሚ ኃላፊነቶች",
    userResponsibilitiesDesc: "እርስዎ መገንዘብ ያለብዎት፡-",
    userResponsibilitiesItem1: "ትክክለኛ መረጃ መስጠት",
    userResponsibilitiesItem2: "የአካዉንት ደህንነት መጠበቅ",
    userResponsibilitiesItem3: "ሕጎችን መከተል",

    providerTermsTitle: "3. ለአቅራቢዎች ደንቦች",
    providerTermsDesc: "አቅራቢዎች መገንዘብ ያለባቸው፡-",
    providerTermsItem1: "ትክክለኛ የአገልግሎት መግለጫ ማስቀመጥ",
    providerTermsItem2: "ሙያዊ ስነምግባር",
    providerTermsItem3: "ወቅታዊ መረጃ ማቅረብ",

    prohibitedActivitiesTitle: "4. የማይፈቀዱ ተግባራት",
    prohibitedActivitiesDesc: "የሚከተሉትን ከማድረግ ይቆጠቡ፡-",
    prohibitedActivitiesItem1: "ሐሰተኛ መረጃ መስጠት",
    prohibitedActivitiesItem2: "ሌሎችን መጉዳት",
    prohibitedActivitiesItem3: "የባለመብት ጥሰት",

    contactInfoTitle: "5. አድራሻችን",
    contactInfoDesc: "ለተጨማሪ መረጃ፡-",
    contactInfoEmail: "support@warkashop.com",

    // Cookie Policy
    cookiePolicyTitle: "የኩኪ ፖሊሲ",
    whatAreCookiesTitle: "ኩኪዎች ምንድን ናቸዉ?",
    whatAreCookiesDesc: "ኩኪዎች በእርስዎ ስልክ ወይም ኮምፒዩተር ላይ የሚቀመጡ አነስተኛ ፋይሎች ናቸው፣ የተሻለ ተሞክሮ ለመስጠት።",

    typesOfCookiesTitle: "የኩኪ ዓይነቶች",
    essentialCookiesTitle: "መሰረታዊ ኩኪዎች",
    essentialCookiesDesc: "ለመሠረታዊ አጠቃቀም አስፈላጊ ናቸዉ።",

    preferenceCookiesTitle: "የምርጫ ኩኪዎች",
    preferenceCookiesDesc: "የእርስዎን ምርጫዎች ያስታውሳሉ።",

    analyticsCookiesTitle: "የትንታኔ ኩኪዎች",
    analyticsCookiesDesc: "የአጠቃቀምን ንድፍ ለማሻሻል ይረዳሉ።",

    managingCookiesTitle: "ኩኪዎችን እንዴት እንደሚቆጣጠሩ",
    managingCookiesDesc1: "በብራውዘር ማስተካከያዎች ውስጥ ማስተካከል ይችላሉ።",
    managingCookiesDesc2: "ለዝርዝር መመሪያ፡-",
    manageCookiesChrome: "በክሮም: ቅንብሮች → ግላዊነት",
    manageCookiesFirefox: "በፋየርፎክስ: አማራጮች → ግላዊነት",
    manageCookiesSafari: "በሳፋሪ: ምርጫዎች → ግላዊነት",

    updatesPolicyTitle: "የፖሊሲ ማዘመን",
    updatesPolicyDesc: "ይህ ፖሊሲ ሊሻሻል ይችላል፣ በየጊዜው ይመልከቱ።",

    
    backToDetails: "ወደ ዝርዝር ተመለስ",
    onlyXLeft: "{{count}} ብቻ ቀርቷል",
    noReviewsYet: "ገና አስተያየት አልተሰጠም፡ አስተያየት በመስጠት የመጀመሪያ ይሁኑ",
    priceDisplay: "{{price}} ብር",

    addNewItem: "አዲስ እቃ ይጨምሩ",
    images: "ምስሎች",
    itemName: "የእቃው ስም",
    priceETB: "ዋጋ (ብር)",
    quantity: "ብዛት",
    category: "የእቃ ምድብ",
    condition: "የእቃ ሁኔታ",
    addingItem: "በመጨመር ላይ...",
    nameRequired: "ስም ያስፈልጋል",
    descriptionRequired: "የእቃ መግለጫ ያስፈልጋል",
    priceRequired: "ዋጋ ያስፈልጋል",
    pricePositive: "ዋጋ ከ0 በላይ መሆን አለበት",
    quantityRequired: "ብዛት ያስፈልጋል",
    quantityPositive: "ብዛት ቢያንስ 1 መሆን አለበት",
    categoryRequired: "የእቃ አይነት ያስፈልጋል",
    conditionRequired: "የእቃ ሁኔታ ያስፈልጋል",
    imageRequired: "እባኮትን ቢያንስ አንድ ምስል ይጨምሩ",
    itemAddedSuccess: "እቃ በተሳካ ሁኔታ ተጨመሯል!",
    itemAddedFail: "እቃ መጨመር አልተሳካም",
    itemUpdatedSuccess: "እቃ ዝርዝር በተሳካ ሁኔታ ተስተካክሏል!",
    itemRemoveSuccess: "እቃ በተሳካ ሁኔታ ተሰርዟል!",
    itemRemoveError: "እቃ መሰረዝ አልተሳካም",
    selectCategory: "የእቃ አይነት ይምረጡ",
    selectServiceCategory: "የአገልግሎት ምድብ",
    selectCondition: "የእቃ ሁኔታ ይምረጡ",

    aiWizardTitle: "በAI የተደገፈ የእቃ ዝርዝር",
    aiWizardStep1: "ፎቶ ይጫኑ",
    aiWizardStep2: "AI ትንተና",
    aiWizardStep3: "ይገምግሙ እና ያተሙ",
    aiWizardCapture: "የእቃዎን ፎቶ ያንሱ ወይም ምስል ይምረጡ",
    aiWizardTakePhoto: "ፎቶ ያንሱ",
    aiWizardChooseGallery: "ከጋለሪ ይምረጡ",
    aiWizardAnalyzing: "AI እቃዎን በመመርመር ላይ...",
    aiWizardAnalyzingDesc: "ምርቱን፣ ምድቡን እና የሚጠቆም ዋጋ በመለየት ላይ",
    aiWizardReview: "ዝርዝሮችዎን ይገምግሙ",
    aiWizardEditHint: "ከመልቀቅዎ በፊት ሁሉንም ዝርዝር በደንብ ያስተካክሉ",
    aiWizardSuggestedPrice: "በAI የተጠቆመ ዋጋ",
    aiWizardRetry: "እንደገና ይሞክሩ",
    aiWizardAnalysisFailed: "ምስሉን መመርመር አልተቻለም። እባኮትን እንደገና ይሞክሩ ወይም በእጅ ይሙሉ።",
    aiWizardFillManually: "በእጅ ዝርዘሩን ይጻፉ",
    aiWizardPoweredBy: "በAI የተደገፈ",
    aiWizardChangeImage: "ምስል ይቀይሩ",
    aiWizardPublish: "ዝርዝር ያተሙ",
    aiWizardNext: "ቀጣይ",
    aiWizardBack: "ተመለስ",
    aiWizardKeywords: "ቁልፍ ቃላት",
    aiWizardPriceRange: "የዋጋ ክልል (ETB)",
    aiWizardListingLanguage: "የእቃ ዝርዝር ቋንቋ",

    imageUploadSuccess: "ምስል በተሳካ ሁኔታ ተጭኗል!",
    imageUploadError: "ምስል መጫን አልተሳካም። እባኮትን እንደገና ይሞክሩ።",
    imageRemoveSuccess: "ምስል በተሳካ ሁኔታ ተሰርዟል!",
    imageRemoveError: "ምስል መሰረዝ አልተሳካም። እባኮትን እንደገና ይሞክሩ።",
    imageAlt: "የተጫነ ምስል",
    dropImage: "ምስሉን እዚህ ያስገቡ",
    dragOrClick: "ምስሉን ይጫኑ",
    supportedFormats: ": JPEG, PNG, WebP",
    writeReview: "አስተያየት ይጻፉ",
    reviewItem: "እቃ ይግምገሙ",
    shareYourExperience: "የእርስዎን ተሞክሮ ያጋሩ",
    shareYourThoughts: "የእርስዎን ሐሳብ ያጋሩ",
    pleaseWriteReview: "እባኮትን አስተያየት ይጻፉ",
    yearsexp : "ዓመት ልምድ",
    setAsUser: "እንደ መደበኛ ተጠቃሚ ይመዝገቡ",
    regularUserDesc: "እንደ መደበኛ ተጠቃሚ አፑን ይጠቀሙ።",
    status: "ሁኔታ",
    buyer: "ገዢ",
    price: "ዋጋ",
    viewSeller: "የሻጭ ገጽ",
    viewProfile: "የገዢ ገፅ",
    pickupLocation: "የእቃ መዉሰጃ ቦታ",
    myPurchases: "የኔ ግዢዎች",
    myStoreOrders: "የመጡ ትዕዛዞች",
    newOrders: "አዲስ",
    changePickupLocation: "የመዉሰጃ ቦታ ይቀይሩ",
    cancelOrder: "ግዢ ሰርዝ",
    pending: "ተልኳል",
    confirmed: "ተቀብሏል",
    confirm: "ገዢ አረጋግጥ",
    ready: "ለመዉሰድ ዝግጁ",
    complete: "የተጠናቀቁ",
    noOrdersFound: "ትእዛዞች የሉም",
    noPurchaseFound: "ግዢዎች የሉም",
    loadingOrders: "ትእዛዞች በመጫን ላይ...",
    // New order system keys (Amharic)
    cart: "ካርት",
    activeOrders: "በሂደት ላይ ያሉ ትዕዛዞች",
    orderHistory: "ታሪክ",
    sendOrders: "ትዕዛዞችን ላክ",
    cartEmpty: "ካርትዎ ባዶ ነው",
    ordersSent: "ትዕዛዞች በተሳካ ሁኔታ ተልከዋል!",
    trackYourOrders: "ግዢዎችዎን እና ትዕዛዞችዎን ይከታተሉ",
    manageIncomingOrders: "ከገዢዎች የሚመጡ ትዕዛዞችን ያስተዳድሩ",
    pendingOrdersNeedAttention: "ትዕዛዞች ትኩረትዎን ይፈልጋሉ",
    itemRemovedFromCart: "እቃ ከካርት ተወግዷል",
    changeLocation: "ቦታ ቀይር",
    locationUpdated: "ቦታ ተዘምኗል",
    orderConfirmed: "ትዕዛዝ ተረጋግጧል",
    orderMarkedReady: "ትዕዛዝ ለመዉሰድ ዝግጁ ሆኗል",
    orderCompleted: "ትዕዛዝ ተጠናቋል",
    orderCancelled: "ትዕዛዝ ተሰርዟል",
    inYourCart: "በካርትዎ ውስጥ",
    item: "እቃ",
    items: "እቃዎች",
    remove: "አስወግድ",
    noLocationSelected: "ቦታ አልተመረጠም",
    total: "ድምር",
    noActiveOrders: "ንቁ ትዕዛዞች የሉም",
    noOrderHistory: "ገና የትዕዛዝ ታሪክ የለም",
    noPendingOrders: "በመጠባበቅ ላይ ያሉ ትዕዛዞች የሉም",
    storeOrders: "የመጡ ትዕዛዞች",
    viewStoreOrders: "የሱቅ ትዕዛዞችን ይመልከቱ",
    viewPurchases: "ግዢዎቼን ይመልከቱ",
    statusPendingBuyerGuide: "ትዕዛዝዎ ተልኳል። ሻጩ እስኪያረጋግጥ በመጠበቅ ላይ።",
    statusConfirmedBuyerGuide: "ሻጩ ትዕዛዝዎን አረጋግጧል። እየተዘጋጀ ነው።",
    statusReadyBuyerGuide: "ትዕዛዝዎ ለመውሰድ ዝግጁ ነው! ለመውሰድ ሻጩን ይጎብኙ።",
    statusCompletedBuyerGuide: "ትዕዛዝ ተጠናቋል። ስለገዙ እናመሰግናለን!",
    statusCancelledBuyerGuide: "ይህ ትዕዛዝ ተሰርዟል።",
    statusPendingSellerGuide: "አዲስ ትዕዛዝ ደርሷል። እባክዎ ይገምግሙ እና ያረጋግጡ።",
    statusConfirmedSellerGuide: "ይህን ትዕዛዝ አረጋግጠዋል። ለገዢው ያዘጋጁ።",
    statusReadySellerGuide: "ትዕዛዝ ዝግጁ ነው። ገዢው እስኪወስድ በመጠበቅ ላይ።",
    statusCompletedSellerGuide: "ትዕዛዝ በተሳካ ሁኔታ ተጠናቋል።",
    statusCancelledSellerGuide: "ይህ ትዕዛዝ ተሰርዟል።",
    statusCartGuide: "እቃ በካርትዎ ውስጥ ነው። ዝግጁ ሲሆኑ ትዕዛዞችዎን ይላኩ።",
   
    sendersTravelers: "በተጓዦች እቃ ይላኩ",
    iAmSender: "ተጓዢ ፈልግ",
    iAmTraveler: "ጉዞ መዝግብ",
    iAmListings: "የእኔ ጉዞዎች",
    travelerDetails: "የተጓዥ ዝርዝሮች",
    fromLocation: "ከየት",
    toLocation: "ወደ የት",
    travelDate: "የጉዞ ቀን",
    maxSize: "ከፍተኛ መጠን",
    maxWeight: "ከፍተኛ ክብደት (Kg)",
    notes: "ማስታወሻዎች",
    saveTravelerDetails: "የተጓዥ ዝርዝሮችን አስቀምጥ",
    senderSearch: "የላኪ ፍለጋ",
    travelDateFrom: "ከ ቀን",
    travelDateTo: "እስከ ቀን",
    itemType: "የእቃ አይነት",
    any: "ማንኛውም",
    fullLuggage: "ሻንጣ",
    singleItem: "ነጠላ እቃ",
    electronics: "ኤሌክትሮኒክስ",
    searchTravelers: "ተጓዦችን ፈልግ",
    searching: "በመፈለግ ላይ...",
    searchResults: "ቀጣይ ጉዞዎች",
    noResultsFound: "በመጫን ላይ",
    listingDetail: "የጉዞዉ መረጃ",
    createdOn: "የተጨመረበት ቀን",
    close: "ዝጋ",
    listingSaveFailure: "ጉዞዉ ማስቀመጥ አልተሳካም",
    listingSaveSuccess: "ጉዞዉ በተሳካ ሁኔታ ተቀምጧል",
    listingFetchFailure: "ጉዞዎችን መጫን አልተሳካም",
    detailFetchFailure: "የጉዞዎች መረጃዎችን መጫን አልተሳካም",
    senderSearchFailure: "ጉዞዎች መፈለግ አልተሳካም",
    noListingsFound: "ምንም ጉዞዎች አልተገኙም",
    deleteListingConfirmation: "ይህን ጉዞ መሰረዝ ይፈልጋሉ?",
    deleteListingFailure: "ጉዞዉን መሰረዝ አልተሳካም።",
    deleteListingSuccess: "ጉዞዉ በተሳካ ሁኔታ ተሰርዟል።",
    travelDateFromBeforeCurrent: "የጉዞ ቀን ዛሬ እና ከዛሬ በፊት መሆን አይችልም።",
    travelDateFromAfterTo: "የጉዞ ቀን አስተካክል።",
    findJobs: "ክፍት የስራ ቦታዎች",
    findEvents: "የመዝናኛና ዝግጅቶች",
    comingSoon: "በቅርቡ ይለቀቃል...",
    phoneVerificationRequired: "የስልክ ምዝገባ በኦቲፒ ማረጋገጫ ያስፈልገዋል። ባለ 6-ዲጂት ኮድ ወደ ስልክዎ ይላካል።",
    emailVerificationSent: "የማረጋገጫ ኢሜይል ወደ ኢሜይል አድራሻዎ ተልኳል",
    checkYourEmail: "ኢሜይልዎን ያረጋግጡ",
    verificationEmailSentDescription: "የማረጋገጫ ኢሜይል ወደ የመልዕክት ሳጥንዎ ልከናል። አካውንትዎን ለማረጋገጥ እባክዎ በኢሜይል ውስጥ ያለውን ሊንክ ይጫኑ።",
    checkSpamFolder: "ኢሜይሉን ካላገኙት እባክዎን የስፓም መልዕክት ማህደርዎን ያረጋግጡ።",
    appliedViaLink: "በሊንክ አማካኝነት ተተግብሯል",
    copy: "ኮፒ ሊንክ",
    share: "ለሌሎች አጋራ",
    levelInfoAriaLabel: "የደረጃ መረጃ አሳይ",
    levelLabel: "ደረጃ",
    payoutLabel: "ክፍያ",
    closeModal: "ዝጋ",
    levelInfoTitle: "የሪፈራል ደረጃዎች እና ክፍያዎች",
    levelInfoDesc1: "አዲስ ተጠቃሚዎችን ወደ ዋርካ በመጥቀስ ነጥቦችን ያግኙ! ብዙ ተጠቃሚዎችን በጠቀሱ እና ብዙ ገጾችን በፈጠሩ ቁጥር ደረጃዎ እና ሊያገኙት የሚችሉት ክፍያ ከፍ ይላል።",
    howToEarnPoints: "ነጥቦች እንዴት ይሰላሉ:",
    pointsPerReferral: "+25 ነጥቦች የእርስዎን ኮድ ተጠቅሞ ለተመዘገበ ለእያንዳንዱ ተጠቃሚ።",
    pointsPerSeller: "+50 ተጨማሪ ነጥቦች የተጠቀሱት ተጠቃሚ የሻጭ ገጽ ከፈጠረ።",
    pointsPerProvider: "+50 ተጨማሪ ነጥቦች የተጠቀሱት ተጠቃሚ የአገልግሎት ሰጪ ገጽ ከፈጠረ።",
    levelsAndPayouts: "ደረጃዎች እና ክፍያዎች:",
    minPointsLabel: "ዝቅተኛው የሚያስፈልጉ ነጥቦች",
    payoutAmountLabel: "የክፍያ መጠን (ብር)",
    payoutInfoNote: "ክፍያዎች የሚፈጸሙት ከላይ በተቀመጡት ደረጃዎችን በመድረስ ነው።",
    shareYourLink: "ሪፈር ሊንክ",
    referralAndEarnings: 'ሪፈራል እና ገቢ ማግኛ መንገዶች',
    referralAndEarningsDesc: 'ሪፈራል ሊንክዎን ለጓደኛ እና የማህበራዊ ሚድያ ተከታዮች ያጋሩ እና ነጥቦችን ያግኙ። ያገኙት ነጥብ ተደምሮ የተለያዩ ደረጃዎች ላይ ሲደርሱ በደረጃው መሰረት የገንዘብ መጠን ያገኛሉ',
    socialMediaIntegration: 'ሶሻል ሚዲያ ማጋራት',
    socialMediaIntegrationDesc: 'ዋርካ ላይ የተቀመጡ ሽያጮችን ወደ ተለያዩ ሶሻል ሚድያ መንገዶች በማጋራት፡ ሻጩ ባስቀመጠው የኮሚሽን መጠን መሰረት ገቢ ማግኘት ይችላሉ፡፡ ሻጭ ያጋሩትን ሊንክ ዕይታዎችን፣ ምዝገባዎችን እና ግዢዎችን መከታተል ይችላሉ።',
    bulkListing: 'የጅምላ ዝርዝሮች',
    bulkListingDesc: 'ብዛት ያላቸዉን እቃዎችን ወደ ዋርካ ለማስገባት የሻጭ ዳሽቦርድን ይጠቀሙ፡፡ በሻጭ ዳሽቦርድ የExcel ኢንቬንቶሪዎችን ወደ እቃ ዝርዝሮችን በአንድ ጊዜ ይፍጠሩ። እቃዎችን እና ታእዛዞችዎን በቀላሉ ይቆጣጠሩ',
    clickAndCollect: 'የእቃ መዉሰጃ ቦታዎች',
    clickAndCollectDesc: 'የገዙትን እቃዎች በአካባቢዎ ያሉ ምቹ የመውሰጃ ቦታዎቻችንን በመምረጥ ይዉሰዶ።',
    getStarted: 'ጀምር',
    exploreNewFeatures: "Explore New Features",

    sharing: "በመጋራት ላይ...",
    postToSocials: "ወደ ሶሻል ሚዲያ ይላኩ",
    openInApp: "በአፕ ውስጥ ይክፈቱ",
    itemSharedSuccessfully: "እቃው በተሳካ ሁኔታ ተጋርቷል",
    linkCopiedToClipboard: "ሊንኩ ወደ ክሊፕቦርድ ተቅድሟል",
    failedToShareItem: "እቃውን መጋራት አልተሳካም",
    loginRequiredToShare: "እቃዎችን ለመጋራት እባክዎ ይግቡ",
    shareItemTitle: "{{itemName}}ን በዋርካ ላይ ይመልከቱ",
    shareItemText: "{{itemName}}ን ከ{{storeName}} በዋርካ ላይ አገኘሁ",
    error: "ስህተት",
    itemNotFound: "እቃው አልተገኘም",
    branchLinkCopied: "የቅርንጫፍ ሊንኩ ወደ ኮንሶል ተቅድሟል (የማሳደጊያ ሁኔታ)",
    sharePreview: "በሶሻል ሚዲያ አጋራ",
    directMessageLink: "የመልእክት ሊንክ",
    postLink: "የፖስት ሊንክ",
    hideListing: 'ዝርዝሩን ደብቅ',
    hideListingInfo: 'እቃው ከስቶክ ውጭ ከሆነ ወይም በገበያ ቦታው ላይ እንዳይታይ ከፈለጉ ይህን ዝርዝር ይደብቁ',
    payoutInfoNote1: "ክፍያዎች የሚፈጸሙት ከላይ በተቀመጡት ደረጃዎችን በመድረስ ነው።",
    payoutInfoNote2: "ለረጅም ጊዜ ያልተንቀሳቀሱ ተጠቃሚዎች፣ ሻጮች እና አገልግሎት አቅራቢዎችን ክፍያ አያስገኙም",
    payoutInfoNote3: "ስለ ክፍያ ብቃት እና ሂደት ሙሉ ዝርዝሮችን ለማግኘት ውሎች እና የክፍያ ሁኔታዎች (Terms and Conditions) ያንብቡ።",

    previewShare: 'ይዘቱን ቅድመ ዕይታ',
    generatingPreview: 'ይዘቱን ቅድመ ዕይታ እየተጠናቀቀ...',
    generateOG: 'ሊንኩን በመፍጠር ላይ...',
    generatingOG: 'ሊንኩን በመፍጠር ላይ...',
    ogImageUrlCopied: 'የምስል ሊንክ ወደ clipboard ኮፒ ተደርጓል',
    failedToGenerateOG: 'ምስል መፍጠር አልተሳካም',
    copyOGImage: 'ኮፒ ምስል ብቻ',
    copyPreviewLink: 'ኮፒ የፖስት ሙሉ ሊንክ',
    previewLinkCopied: 'ቅድመ ዕይታ ሊንክ ወደ clipboard ኮፒ ተደርጓል',
    failedToGeneratePreview: 'ቅድመ ዕይታ ሊንክ መፍጠር አልተሳካም',
    generatingLinks: 'ሊንኩን በመፍጠር ላይ...',
    copyBranchUrl: 'ኮፒ የእቃ ሊንክ',
    branchUrlCopied: 'የእቃዉ ሊንክ ወደ clipboard ኮፒ ተደርጓል',
    failedToGenerateBranchUrl: 'የእቃዉን ሊንክ መፍጠር አልተሳካም',
    whatsappVerificationRequired: 'ስልክ ቁጥርዎን ለማረጋገጥ በWhatsApp የሚላክ ኮድ ያስፈልጋል። የማረጋገጫ ኮድ በWhatsApp ይላክልዎታል።',
    whatsappVerificationInfo: 'የማረጋገጫ ኮድ በWhatsApp ይላክልዎታል። እባክዎ WhatsApp በስልክዎ ላይ መጫን እና መልእክት መቀበል መቻልዎን ያረጋግጡ።',
    whatsappLoginInfo: 'የማረጋገጫ ኮድ በWhatsApp ይላክልዎታል። እባክዎ WhatsApp በስልክዎ ላይ መጫን እና መልእክት መቀበል መቻልዎን ያረጋግጡ።',
    whatsappOtpSent: 'እባክዎ የማረጋገጫ ኮድዎን በWhatsApp ይፈልጉ',
    telegramVerificationRequired: 'ስልክ ቁጥርዎን ለማረጋገጥ በTelegram የሚላክ ኮድ ያስፈልጋል። የማረጋገጫ ኮድ በTelegram ይላክልዎታል።',
    telegramVerificationInfo: 'የማረጋገጫ ኮድ በTelegram ይላክልዎታል። እባክዎ Telegram በስልክዎ ላይ መጫን እና መልእክት መቀበል መቻልዎን ያረጋግጡ።',
    telegramLoginInfo: 'የማረጋገጫ ኮድ በTelegram ይላክልዎታል። እባክዎ Telegram በስልክዎ ላይ መጫን እና መልእክት መቀበል መቻልዎን ያረጋግጡ።',
    telegramOtpSent: 'እባክዎ የማረጋገጫ ኮድዎን በTelegram ይፈልጉ',
    emailVerificationRequired: 'ጠቃሚ መረጃ፡ ወደ አካውንትዎ ለመግባት የላክንልዎትን የኢሜይል ማረጋገጫ ሊንክ መጫን አለብዎት።',
    bookAppointment: "ቀጠሮ ያስይዙ",
    selectService: "አገልግሎት ይምረጡ",
    selectDate: "ቀን ይምረጡ",
    selectTime: "ሰዓት ይምረጡ",
    bookingConfirmed: "ቀጠሮው ተያዘ!",
    appointmentScheduled: "ቀጠሮዎ በተሳካ ሁኔታ ተይዟል",
    appointmentScheduledEth: "የ{{service}} ቀጠሮዎ ለ{{dateTime}} ተይዟል",
    queueNumber: "የወረፋ ቁጥር",
    dateAndTime: "ቀን እና ሰዓት",
    counter: "ካውንተር",
    enabled: "በርቷል",
    notEnabled: "አልበራም",
    bookAnotherAppointment: "ሌላ ቀጠሮ ያስይዙ",
    backToProfile: "ወደ ፕሮፋይል ይመለሱ",
    today: "ዛሬ",
    currentWeek: "የአሁኑ ሳምንት",
    nextWeek: "የሚቀጥለው ሳምንት",
    countersAvailable: "ካውንተሮች ይገኛሉ",
    counterAvailable: "ካውንተር ይገኛል",
    calendarType: "የቀን መቁጠሪያ አይነት",
    switchToEthiopian: "ወደ ኢትዮጵያዊ ቀን አቆጣጠር ቀይር",
    switchToGregorian: "ወደ ግሪጎሪያን ቀን አቆጣጠር ቀይር",
  
    note: "ማስታወሻ፡ ለዚህ ቀጠሮ ማሳወቂያዎችን ማስቻል አልተቻለም። የማሳወቂያ ፈቃዶችን ማረጋገጥ ሊያስፈልግዎት ይችላል።",
    tryEnablingNotificationsAgain: "ማሳወቂያዎችን እንደገና ለማስቻል ይሞክሩ",
    upcoming: "መጪ ቀጠሮዎች",
    completed: "የተጠናቀቁ",
    cancelled: "የተሰረዙ",
    scheduled: "ተይዟል",
    in_progress: "በሂደት ላይ",
    scanToCheckIn: "ለማረጋገጥ ስካን ያድርጉ",
  }
};